{
  "Layer PDF Editor": "PDF Editor layers",
  "Đối tượng": "Object",
  "Chữ": "Text",
  "Ảnh": "Image",
  "Layer đối tượng": "Object layers",
  "Số layer được chọn / tổng số": "Selected layers / total",
  "Thao tác layer": "Layer actions",
  "Thứ tự layer từ trên xuống dưới": "Layer order from front to back",
  "Màu đánh dấu": "Label color",
  "Màu đánh dấu layer": "Layer label color",
  "Bỏ màu đánh dấu": "Clear label color",
  "Shift: chọn dải · Ctrl/⌘: chọn nhiều. Kéo hoặc Alt + ↑/↓ để đổi thứ tự. Bấm đúp tên để đổi tên.": "Shift: select range · Ctrl/⌘: select multiple. Drag or Alt + ↑/↓ to reorder. Double-click a name to rename.",
  "Nền PDF gốc cố định; layer là đối tượng thêm vào.": "The original PDF is a fixed background; layers are added objects.",
  "Nền PDF gốc": "Original PDF background",
  "Nội dung PDF gốc là nền cố định. Layer quản lý các đối tượng được thêm trong trình chỉnh sửa.": "The original PDF content is a fixed background. Layers manage objects added in the editor.",
  "Chọn tất cả layer": "Select all layers",
  "Đưa lên một lớp": "Bring forward",
  "Đưa xuống một lớp": "Send backward",
  "Nhóm layer": "Group layers",
  "Bỏ nhóm layer": "Ungroup layers",
  "Ẩn / hiện layer đã chọn": "Hide / show selected layers",
  "Xóa layer đã chọn": "Delete selected layers",
  "Chọn layer": "Select layer",
  "Ẩn layer": "Hide layer",
  "Hiện layer": "Show layer",
  "Mở nhóm": "Expand group",
  "Thu gọn nhóm": "Collapse group",
  "Tên layer": "Layer name",
  "Thêm chữ, ảnh hoặc hình để tạo layer.": "Add text, images or shapes to create layers.",
  "Chọn trang PDF để xem layer.": "Select a PDF page to view layers.",
  "Hình chữ nhật": "Rectangle",
  "Tam giác": "Triangle",
  "Hình elip": "Ellipse",
  "Đường thẳng": "Line",
  "Mũi tên": "Arrow",
  "Dựng lại vùng đen hoặc từng vùng màu trong ảnh thành path vector riêng, xuất SVG.": "Trace black areas or individual color regions into separate vector paths and export SVG.",
  "Vùng màu → SVG": "Color regions → SVG",
  "Halftone & vector": "Halftone & vector",
  "Prompt poster AI miễn phí - Update thường xuyên": "Free AI poster prompts - Updated regularly",
  "Danh sách prompt": "Prompt list",
  "Phân trang prompt": "Prompt pagination",
  "Hiển thị {0}–{1} trong {2} mẫu": "Showing {0}–{1} of {2} templates",
  "Trước": "Previous",
  "Sau": "Next",
  "Tùy chỉnh thương hiệu, nguyên liệu và phong cách từ các mẫu poster đồ uống, rồi sao chép prompt để dùng với dịch vụ tạo ảnh của bạn.": "Customize the brand, ingredients and style of beverage poster templates, then copy your prompt for your image generation service.",
  "Khám phá": "Discover",
  "Công cụ": "Tools",
  "Tài nguyên": "Resources",
  "Điều hướng chính": "Main navigation",
  "Mở tìm kiếm": "Open search",
  "Đã lưu": "Saved",
  "Đóng menu": "Close menu",
  "Mở menu": "Open menu",
  "Không tìm thấy trang": "Page not found",
  "Đường dẫn này không còn tồn tại hoặc đã được nhập sai.": "This address no longer exists or was entered incorrectly.",
  "Về trang chủ": "Back to home",
  "Không gian sáng tạo của bạn.": "Your creative space.",
  "Chưa có ảnh": "No image yet",
  "Vui lòng chọn file ảnh hợp lệ.": "Please choose a valid image file.",
  "Không thể đọc ảnh này.": "Unable to read this image.",
  "Tất cả công cụ": "All tools",
  "Điều khiển Color Halftone": "Color Halftone controls",
  "Ảnh đầu vào": "Input image",
  "Thông tin ảnh": "Image information",
  "Hiệu ứng": "Effect",
  "Chọn màu hạt": "Choose dot color",
  "Màu hạt": "Dot color mode",
  "Một màu": "Single color",
  "Nhiều màu": "Multicolor",
  "Mỗi chấm lấy màu tại vị trí tương ứng trong ảnh.": "Each dot takes the image color at its position.",
  "Thông số hạt": "Dot settings",
  "Khu vực xem trước": "Preview area",
  "Kéo ảnh vào khung hoặc chọn Import image": "Drop an image here or select Import image",
  "Preview ảnh halftone": "Halftone image preview",
  "hoặc bấm Import image để bắt đầu": "or select Import image to get started",
  "TÌM KIẾM": "SEARCH",
  "Tìm đúng thứ bạn cần": "Find what you need",
  "Đóng tìm kiếm": "Close search",
  "Ví dụ: PDF, branding, font...": "For example: PDF, branding, fonts...",
  "Chưa có kết quả phù hợp. Thử từ khóa ngắn hơn.": "No matching results. Try a shorter search.",
  "Enter để mở kết quả": "Enter to open a result",
  "Esc để đóng": "Esc to close",
  "Kho tài nguyên được chọn lọc": "Curated design resources",
  "Những thứ bạn đã lưu": "Your saved items",
  "Nguồn tham khảo, font, mockup và checklist giúp quyết định thiết kế nhanh hơn.": "References, fonts, mockups and checklists to help you make design decisions faster.",
  "Các mục được lưu trên thiết bị này. Chưa có đồng bộ tài khoản.": "Items are saved on this device. Account sync is not available yet.",
  "BỘ SƯU TẬP CỦA BẠN": "YOUR COLLECTION",
  "mục": "items",
  "Tìm trong danh mục này...": "Search this collection...",
  "Tìm trong danh mục": "Search collection",
  "Bộ lọc": "Filters",
  "Chưa có mục nào được lưu": "No saved items yet",
  "Không tìm thấy kết quả": "No results found",
  "Bấm biểu tượng lưu trên một card để giữ lại cho lần sau.": "Select the bookmark icon on a card to save it for later.",
  "Thử xóa bớt từ khóa hoặc bỏ bộ lọc.": "Try fewer keywords or clear the filters.",
  "Ở đây có chút công cụ cho": "A few useful tools for",
  "designer mới nhú": "designers getting started",
  "Một số công cụ có thể hữu ích cho người bắt đầu thiết kế, đúng hơn đây là web tôi làm để phục vụ công việc cho bản thân nhưng biết đâu nó cũng giúp được cho bạn": "A collection of tools for designers getting started. I built this site for my own work, and I hope it helps yours too.",
  "Thấy hay thì cho tôi xin 1 tràng pháo tay là được :)))": "If you find it useful, a little applause is all I ask :)))",
  "Bộ sưu tập nổi bật": "Featured collections",
  "Mở Barcode Generator": "Open Barcode Generator",
  "Cần thêm code khác, cần bổ sung thêm chức năng thì liên hệ": "Need another barcode format or feature? Get in touch.",
  "Mở Image Filter Lab trong danh sách công cụ": "Open Image Filter Lab in the tools collection",
  "Công cụ chuyển ảnh thành các hiệu ứng (Phù hợp in Flexo)": "Turn images into effects suitable for flexographic printing",
  "Mở Prompt Library": "Open Prompt Library",
  "Promt poster tùm lum tùm la sẽ update dần thêm": "An assortment of poster prompts, with more coming over time",
  "Khám phá theo nhu cầu": "Explore by task",
  "Công việc nhỏ.": "Small tasks.",
  "Tiến độ lớn.": "Big progress.",
  "Bộ công cụ thiết kế, luôn trong tầm tay.": "Design tools, always within reach.",
  "Thư viện cảm hứng": "A library of inspiration",
  "Khám phá tài nguyên": "Explore resources",
  "Mã vạch & QR": "Barcodes & QR",
  "Chuyển đổi & biên tập": "Convert & edit",
  "Chuyển đổi ảnh & GIF": "Image & GIF conversion",
  "Danh mục công cụ": "Tool categories",
  "BỘ LỌC": "FILTERS",
  "Chọn công cụ": "Choose a tool",
  "Nhóm công cụ": "Tool groups",
  "Chạy trực tiếp trên trình duyệt": "Runs in your browser",
  "Không cần tải lên máy chủ.": "No server upload needed.",
  "Đã chọn:": "Selected:",
  "Tìm công cụ...": "Search tools...",
  "Tìm công cụ": "Search tools",
  "Sắp xếp": "Sort",
  "Sắp xếp công cụ": "Sort tools",
  "Đề xuất": "Recommended",
  "Tên A–Z": "Name A–Z",
  "Chưa có công cụ phù hợp": "No matching tools",
  "Thử từ khóa khác hoặc chọn lại nhóm công cụ.": "Try a different search or select another tool group.",
  "Một số file không phải định dạng ảnh.": "Some files are not supported images.",
  "Chỉ nhận file PDF.": "Only PDF files are accepted.",
  "Đã tạo {0}": "Created {0}",
  "Không thể tạo PDF.": "Unable to create PDF.",
  "Khu vực thả file cho {0}": "Drop files for {0}",
  "Đưa {0} lên trước": "Move {0} up",
  "Đưa {0} xuống sau": "Move {0} down",
  "Xóa {0}": "Remove {0}",
  "Chọn file cho {0}": "Choose files for {0}",
  "+ Thêm file": "+ Add files",
  "Kích thước trang": "Page size",
  "Chất lượng ảnh": "Image quality",
  "Mức nén PDF": "PDF compression",
  "Đang xử lý…": "Processing…",
  "Đã tạo {0} file {1}.": "Created {0} {1} files.",
  "Đã tạo {0}.": "Created {0}.",
  "Không thể tạo file.": "Unable to create file.",
  "Mẫu {0}": "Example {0}",
  "Thêm input cho {0}": "Add an input for {0}",
  "Bớt một input của {0}": "Remove an input for {0}",
  "Định dạng xuất {0}": "Export format for {0}",
  "Đang tạo {0}...": "Creating {0}...",
  "Bỏ lưu {0}": "Unsave {0}",
  "Lưu {0}": "Save {0}",
  "Sẵn sàng": "Ready",
  "Mở tool": "Open tool",
  "CÔNG CỤ": "TOOLS",
  "TÀI NGUYÊN": "RESOURCES",
  "Sẵn sàng trên trình duyệt": "Ready in your browser",
  "01 · NHẬP": "01 · INPUT",
  "Thông tin mã": "Barcode information",
  "Bắt đầu với file của bạn": "Start with your file",
  "Nội dung mã": "Barcode content",
  "Nhập chuỗi hoặc mã sản phẩm...": "Enter text or a product code...",
  "Giữ số 0 đầu và nhập mỗi mã trên một dòng nếu cần.": "Keep leading zeros. Enter one code per line if needed.",
  "Loại mã": "Barcode type",
  "Chọn hoặc kéo thả tệp vào đây": "Choose or drop a file here",
  "Kéo tệp vào đây": "Drop a file here",
  "Tệp đã sẵn sàng để xử lý": "Your file is ready to process",
  "hoặc chọn từ thiết bị của bạn": "or choose from your device",
  "Kiểm soát file lớn và định dạng ở bước xử lý": "File size and format are checked during processing",
  "Tạo bản xem trước": "Create preview",
  "Chọn file": "Choose file",
  "02 · XEM TRƯỚC": "02 · PREVIEW",
  "Kết quả hiển thị ở đây": "Your result appears here",
  "Đã có dữ liệu": "Input ready",
  "Đang chờ input": "Waiting for input",
  "Bản xem trước {0}": "{0} preview",
  "Nhập mã để xem trước": "Enter a code to preview it",
  "Tệp đã nhận": "File received",
  "Output sẽ xuất hiện ở đây sau khi bạn hoàn tất bước đầu tiên.": "Your output will appear here after you complete the first step.",
  "Lưu preset": "Save preset",
  "Xuất file": "Export file",
  "GỢI Ý": "TIP",
  "Một mã rõ ràng bắt đầu từ dữ liệu đúng.": "A clear barcode starts with correct data.",
  "Giữ mọi bước rõ ràng và có thể quay lại.": "Keep each step clear and easy to revisit.",
  "Prototype này đã đặt sẵn ranh giới cho input, preview và export. Engine chuyên biệt sẽ được nối theo migration matrix sau khi baseline nguồn hoàn tất.": "This prototype prepares input, preview and export boundaries. Dedicated engines will follow the migration plan after source verification.",
  "Đang mở PDF Editor": "Opening PDF Editor",
  "Chuẩn bị công cụ chỉnh sửa trên thiết bị…": "Preparing the editor on your device…",
  "PDF Editor — chỉnh sửa và xuất PDF": "PDF Editor — edit and export PDFs",
  "Tạo mã chuẩn, xem trước và xuất file cho quy trình in ấn.": "Generate standard barcodes, preview and export files for print workflows.",
  "Mã & in ấn": "Codes & printing",
  "6 chuẩn mã": "6 barcode standards",
  "Chuỗi văn bản": "Text",
  "Ảnh thành PDF": "Images to PDF",
  "Gom nhiều ảnh thành PDF, đổi thứ tự và chọn kích thước giấy.": "Combine images into a PDF, reorder them and choose a page size.",
  "Nhiều ảnh": "Multiple images",
  "Import ảnh": "Import images",
  "A4 dọc/ngang": "A4 portrait/landscape",
  "Ghép PDF": "Merge PDF",
  "Sắp xếp, gộp và kiểm tra các trang PDF trong một luồng gọn.": "Reorder, merge and check PDF pages in one workflow.",
  "Nén": "Compression",
  "Theo thứ tự": "In order",
  "Thêm chữ, ảnh, shape, line và tinh chỉnh trang PDF.": "Add text, images, shapes and lines, and adjust PDF pages.",
  "Editor nâng cao": "Advanced editor",
  "Tạo các trường nhập liệu, checkbox và chữ ký trên PDF rồi xuất form có thể điền.": "Create text fields, checkboxes and signature areas, then export a fillable PDF.",
  "Form tương tác": "Interactive forms",
  "Biến ảnh thành hiệu ứng halftone với kiểm soát kích thước hạt.": "Turn an image into halftone effects with adjustable dot sizes.",
  "Hình ảnh": "Images",
  "4 kiểu hạt": "4 dot shapes",
  "Ảnh thành GIF": "Images to GIF",
  "Ghép nhiều ảnh, sắp xếp thứ tự và chỉnh thời gian từng khung hình.": "Combine images, arrange frames and adjust their duration.",
  "Ảnh động": "Animation",
  "Tối đa 80 ảnh": "Up to 80 images",
  "Sắp xếp ảnh": "Reorder images",
  "Thời gian mỗi ảnh": "Frame duration",
  "Xem trước": "Preview",
  "Xuất GIF": "Export GIF",
  "Video thành GIF": "Video to GIF",
  "Cắt một đoạn video ngắn, chọn FPS và chuyển thành GIF.": "Trim a short video, choose the frame rate and convert it to GIF.",
  "Đoạn tối đa 20 giây": "Up to 20 seconds",
  "Cắt đoạn": "Trim clip",
  "Video trình duyệt hỗ trợ": "Browser-supported video",
  "Chuyển đổi định dạng ảnh trực tiếp trong thẻ; nhiều ảnh được đóng gói ZIP.": "Convert image formats directly in the card; multiple images download as a ZIP.",
  "Một ảnh hoặc ZIP": "Single image or ZIP",
  "Chuyển định dạng": "Convert formats",
  "Xử lý nhiều ảnh": "Batch processing",
  "Tự nhận diện nguồn": "Automatic format detection",
  "Resize hàng loạt về khung chung hoặc scale theo một cạnh, giữ tỷ lệ từng ảnh.": "Batch resize images into a shared canvas or scale one side while preserving each image's aspect ratio.",
  "Kích thước": "Dimensions",
  "Giữ tỷ lệ · tải ZIP": "Keep proportions · download ZIP",
  "Resize hàng loạt": "Batch resize",
  "Thêm phần dư": "Add padding",
  "In ấn": "Print",
  "6 bước": "6 steps",
  "Quy trình": "Workflow",
  "Hướng dẫn": "Guide",
  "Poster nước trái cây với splash và không khí mùa hè.": "A fruit drink poster with splashes and a summer atmosphere.",
  "10 trường": "10 fields",
  "Poster đồ uống cao cấp với pedestal, nền tối và splash.": "A premium drink poster with a pedestal, dark background and splashes.",
  "12 trường": "12 fields",
  "Macro sản phẩm giữa những khối đá chứa trái cây.": "A product macro surrounded by ice cubes containing fruit.",
  "7 trường": "7 fields",
  "Hero sản phẩm với nguyên liệu và splash chuyển động.": "A product hero with ingredients and dynamic splashes.",
  "13 trường": "13 fields",
  "Bối cảnh lifestyle ngoài trời với giỏ mây và nguyên liệu tự nhiên.": "An outdoor lifestyle scene with a wicker basket and natural ingredients.",
  "1 trường": "1 field",
  "Trái cây và sản phẩm trên platform acrylic bóng.": "Fruit and a product on a glossy acrylic platform.",
  "5 trường": "5 fields",
  "Key visual đồ uống trái cây với splash đóng băng chuyển động.": "A fruit drink visual with frozen splashes in motion.",
  "Lon sữa dừa dâu tây giữa đá lạnh và trái cây tươi.": "A strawberry coconut milk can surrounded by ice and fresh fruit.",
  "2 trường": "2 fields",
  "Công cụ thiết kế miễn phí | DesignForge": "Free design tools | DesignForge",
  "Tài nguyên thiết kế | DesignForge": "Design resources | DesignForge",
  "Thư viện prompt | DesignForge": "Prompt library | DesignForge",
  "Đã lưu | DesignForge": "Saved | DesignForge",
  "Không tìm thấy trang | DesignForge": "Page not found | DesignForge",
  "Trang này không tồn tại trên DesignForge.": "This page does not exist on DesignForge.",
  "Promt tạo ảnh sản phẩm nước trái cây trên mặt nước splash": "Fruit drink product prompt with water splashes",
  "Poster nước trái cây · CGI mùa hè": "Fruit drink poster · Summer CGI",
  "Poster mẫu ELD Mango với trái xoài và water splash": "ELD Mango sample poster with mango and water splashes",
  "Thương hiệu": "Brand",
  "Tên sản phẩm": "Product name",
  "Hương vị chính": "Main flavor",
  "Trái cây chính": "Main fruit",
  "Xoài tươi": "Fresh mango",
  "Màu chủ đạo": "Primary color",
  "Vàng cam": "Yellow-orange",
  "Màu bổ trợ": "Supporting colors",
  "Xanh lá đậm, trắng, xanh cyan": "Dark green, white, cyan",
  "Slogan chính": "Main slogan",
  "Dòng mô tả phụ": "Supporting description",
  "Màu nhấn chữ": "Text accent color",
  "Vàng cam đậm": "Deep orange-yellow",
  "Tỷ lệ poster": "Poster aspect ratio",
  "Promt poster đồ uống cao cấp với pedestal và splash": "Premium drink poster prompt with a pedestal and splashes",
  "Poster đồ uống · Luxury studio CGI": "Drink poster · Luxury studio CGI",
  "Poster Tamarind Juice nền tối với pedestal và splash màu hổ phách": "Tamarind Juice poster with a dark background, pedestal and amber splashes",
  "Loại sản phẩm": "Product type",
  "Nước trái cây": "Fruit juice",
  "Nguyên liệu chính": "Main ingredient",
  "Quả me": "Tamarind fruit",
  "Nguyên liệu phụ": "Supporting ingredient",
  "Lá me": "Tamarind leaves",
  "Không có": "None",
  "Màu campaign": "Campaign color",
  "Cam nâu / hổ phách": "Brown-orange / amber",
  "Màu nhấn phụ": "Secondary accent color",
  "Trắng": "White",
  "Màu nước splash": "Splash color",
  "Cam hổ phách trong suốt": "Transparent amber-orange",
  "Cao cấp / tự nhiên / sang trọng / năng động / thanh khiết": "Premium / natural / elegant / energetic / pure",
  "Promt quảng cáo macro sản phẩm giữa đá trái cây": "Product macro prompt surrounded by fruit ice",
  "Macro sản phẩm · Đá trái cây siêu chân thực": "Product macro · Photorealistic fruit ice",
  "Tùy chỉnh màu sắc & tỷ lệ": "Customize colors & aspect ratio",
  "Poster Ayola Jus de Pomme giữa các khối đá chứa táo đông lạnh": "Ayola Jus de Pomme poster surrounded by frozen apple ice cubes",
  "Sản phẩm": "Product",
  "Lon nước ép táo Jus de pomme thương hiệu Ayola": "Ayola Jus de pomme apple juice can",
  "Trái cây trong đá": "Fruit in the ice",
  "Táo đỏ": "Red apple",
  "Màu thương hiệu": "Brand color",
  "Trắng và đỏ": "White and red",
  "Màu phản chiếu": "Reflection color",
  "Đỏ ruby": "Ruby red",
  "Màu nền đậm": "Dark background color",
  "Đỏ burgundy đậm": "Deep burgundy red",
  "Tỷ lệ ảnh": "Image aspect ratio",
  "Promt quảng cáo sản phẩm với nguyên liệu và splash năng động": "Product advertising prompt with ingredients and dynamic splashes",
  "Hero product · Splash nguyên liệu năng động": "Product hero · Dynamic ingredient splashes",
  "Tùy chỉnh nguyên liệu, màu sắc & bố cục": "Customize ingredients, colors & composition",
  "Poster lon ELD Tamarind với trái me, lá me và splash nước": "ELD Tamarind can poster with tamarind fruit, leaves and water splashes",
  "Lon nước giải khát": "Soft drink can",
  "Hương vị": "Flavor",
  "Trái me": "Tamarind",
  "Trang trí phụ": "Supporting decoration",
  "Trái me, lá me": "Tamarind fruit and leaves",
  "Màu nền": "Background color",
  "Nâu đỏ": "Reddish brown",
  "Màu ánh sáng": "Lighting color",
  "Cam vàng": "Golden orange",
  "Phong cách năng lượng": "Energy style",
  "Tươi mát / mạnh mẽ / ngọt ngào / cao cấp / thiên nhiên": "Refreshing / bold / sweet / premium / natural",
  "Hiệu ứng nước": "Water effect",
  "Vừa": "Medium",
  "Nhẹ": "Light",
  "Mạnh": "Strong",
  "2:3 dọc": "2:3 portrait",
  "4:5 dọc": "4:5 portrait",
  "9:16 dọc": "9:16 portrait",
  "Khoảng trống": "Empty space",
  "Không cần khoảng trống đặt chữ": "No empty space for text needed",
  "Không xuất hiện": "Exclude",
  "Người, chữ quảng cáo, slogan, logo phát sinh, watermark": "People, advertising text, slogans, extra logos, watermarks",
  "Promt quảng cáo lifestyle ngoài trời với giỏ mây": "Outdoor lifestyle advertising prompt with a wicker basket",
  "Lifestyle ngoài trời · Giỏ mây thiên nhiên": "Outdoor lifestyle · Natural wicker basket",
  "Poster chai Aloe Vera trong giỏ mây cạnh hồ nước và các nhánh nha đam": "Aloe Vera bottle poster in a wicker basket beside water and aloe stems",
  "Vật thể trong giỏ": "Objects in the basket",
  "Các nhánh nha đam tươi sạch, mát mắt; một chén thủy tinh chứa nha đam nạo trong suốt và tươi mát": "Fresh, clean aloe stems and a glass bowl of fresh transparent aloe flesh",
  "Promt quảng cáo trái cây trên platform acrylic nghiêng": "Fruit advertising prompt on a tilted acrylic platform",
  "Tùy chỉnh màu sắc, slogan & tỷ lệ": "Customize colors, slogan & aspect ratio",
  "Poster nước dưa hấu giữa trái cây tươi trên platform bóng màu đỏ hồng": "Watermelon drink poster with fresh fruit on a glossy pink-red platform",
  "Cam sáng / cam vàng": "Bright orange / golden orange",
  "Trái cây": "Fruit",
  "Cam tươi": "Fresh oranges",
  "Promt quảng cáo đồ uống trái cây premium splash": "Premium fruit drink splash advertising prompt",
  "Tùy chỉnh slogan, mô tả & tỷ lệ": "Customize slogan, description & aspect ratio",
  "Poster lon nước cam 1UP 700 giữa splash cam, đá viên và lát cam": "1UP 700 orange drink can poster with orange splashes, ice cubes and orange slices",
  "Trái Cam": "Orange",
  "Promt quảng cáo lon sữa dừa dâu tây giữa đá lạnh": "Strawberry coconut milk can advertising prompt surrounded by ice",
  "Poster lon Achoura Coconut Milk Drink giữa dâu tây tươi và đá viên": "Achoura Coconut Milk Drink can poster with fresh strawberries and ice cubes",
  "Màu nền / tông màu": "Background color / tone",
  "Trắng lạnh pha hồng nhạt": "Cool white with pale pink",
  "Dâu tây": "Strawberries",
  "Poster nước giải khát": "Drink posters",
  "Nước trái cây, sữa, cà phê, tăng lực và thức uống thiên nhiên.": "Fruit juice, milk drinks, coffee, energy drinks and natural beverages.",
  "Tất cả": "All",
  "Tăng lực": "Energy drinks",
  "Poster thực phẩm": "Food posters",
  "Món ăn, bánh ngọt và sản phẩm thực phẩm đóng gói.": "Meals, desserts and packaged food products.",
  "Đồ ăn nhanh": "Fast food",
  "Bánh & tráng miệng": "Cakes & desserts",
  "Thực phẩm đóng gói": "Packaged food",
  "Poster sản phẩm làm đẹp": "Beauty product posters",
  "Skincare, mỹ phẩm và sản phẩm chăm sóc cá nhân.": "Skincare, cosmetics and personal care products.",
  "Mỹ phẩm": "Cosmetics",
  "Chăm sóc cá nhân": "Personal care",
  "Phân loại prompt": "Prompt categories",
  "THƯ VIỆN PROMPT": "PROMPT LIBRARY",
  "Chọn chủ đề": "Choose a topic",
  "PHÂN LOẠI": "CATEGORIES",
  "Nhóm con của {0}": "Subcategories of {0}",
  "Tìm tên mẫu, phong cách hoặc nguyên liệu...": "Search templates, styles or ingredients...",
  "Tìm trong thư viện prompt": "Search prompt library",
  "mẫu phù hợp": "matching templates",
  "Mở mẫu {0}": "Open {0} template",
  "trường có thể chỉnh": "editable fields",
  "Lưu mẫu": "Save template",
  "Không tìm thấy prompt": "No prompts found",
  "Chưa có mẫu {0}": "No {0} templates yet",
  "Thử tên sản phẩm, nguyên liệu hoặc phong cách ngắn hơn.": "Try a shorter product, ingredient or style name.",
  "Các mẫu thuộc nhóm này sẽ được bổ sung dần. Bạn có thể chọn một chủ đề khác để tiếp tục.": "More templates will be added to this category. Select another topic to continue.",
  "Đóng trình tạo prompt": "Close prompt editor",
  "Ảnh mẫu poster": "Poster preview",
  "Hãy điền các trường bắt buộc:": "Please fill in the required fields:",
  "Thông tin chính": "Main information",
  "Tùy chỉnh nâng cao": "Advanced options",
  "Đặt lại": "Reset",
  "Tạo prompt": "Generate prompt",
  "Prompt hoàn chỉnh": "Complete prompt",
  "KẾT QUẢ": "RESULT",
  "ký tự": "characters",
  "Nội dung prompt hoàn chỉnh": "Complete prompt content",
  "Đã sao chép": "Copied",
  "Sao chép prompt": "Copy prompt",
  "Mở Gemini": "Open Gemini",
  "Mở Dola": "Open Dola",
  "Prompt sẽ xuất hiện ở đây": "Your prompt appears here",
  "Điền thông tin và bấm “Tạo prompt”. Bạn vẫn có thể sửa nội dung trước khi sao chép.": "Fill in the information and select “Generate prompt”. You can edit the result before copying it.",
  "Tùy chọn": "Optional",
  "Không thể chuyển đổi ảnh.": "Unable to convert image.",
  "Không thể đọc TIFF: {0}": "Unable to read TIFF: {0}",
  "Trình duyệt không hỗ trợ canvas.": "Your browser does not support canvas.",
  "Hãy chọn ít nhất một ảnh.": "Please choose at least one image.",
  "Hãy chọn ít nhất một file PDF.": "Please choose at least one PDF file.",
  "Không thể đọc PDF: {0}": "Unable to read PDF: {0}",
  "Văn bản": "Text",
  "Ngày tháng": "Date",
  "Chữ ký": "Signature",
  "Ô nhập văn bản": "Text input field",
  "Ô chọn bật / tắt": "Checkbox",
  "Ô nhập ngày": "Date input field",
  "Vùng ký tên": "Signature area",
  "Không thể tải bộ đọc PDF.": "Unable to load the PDF reader.",
  "Import PDF để bắt đầu tạo form.": "Import a PDF to start creating a form.",
  "Không còn thao tác để hoàn tác.": "Nothing left to undo.",
  "Đã hoàn tác thao tác gần nhất.": "Undid the last action.",
  "Đã sao chép {0} trường. Nhấn Ctrl + V để dán.": "Copied {0} fields. Press Ctrl + V to paste.",
  "Đã dán {0} trường với hậu tố “_copy”.": "Pasted {0} fields with the “_copy” suffix.",
  "Không thể hiển thị trang PDF.": "Unable to display this PDF page.",
  "Vui lòng chọn file PDF hợp lệ.": "Please choose a valid PDF file.",
  "Đang mở PDF…": "Opening PDF…",
  "PDF không có trang nào.": "This PDF has no pages.",
  "{0} trang · Đã nạp {1} trường có sẵn · Kéo trên trang để thêm trường.": "{0} pages · Loaded {1} existing fields · Drag on the page to add fields.",
  "{0} trang · Kéo trên trang để tạo trường form.": "{0} pages · Drag on the page to create form fields.",
  "Không thể đọc PDF.": "Unable to read PDF.",
  "Tên “{0}” đã tồn tại, đã đổi thành “{1}”.": "The name “{0}” already exists. Renamed to “{1}”.",
  "Đã đổi tên {0} trường theo thứ tự {1}.": "Renamed {0} fields in {1} order.",
  "trái qua phải, từ trên xuống dưới": "left to right, top to bottom",
  "trên xuống dưới, từ trái qua phải": "top to bottom, left to right",
  "Hãy import PDF và tạo ít nhất một trường form.": "Import a PDF and create at least one form field.",
  "Đang tạo form PDF…": "Creating PDF form…",
  "PDF xuất ra không có dữ liệu.": "The exported PDF contains no data.",
  "Đã tạo {0} trường form có thể điền.": "Created {0} fillable form fields.",
  "Không thể tạo form PDF.": "Unable to create PDF form.",
  "Tạo form cho PDF": "Create a PDF form",
  "Import tài liệu, kéo khung trường lên từng trang rồi tải xuống PDF có thể điền như Acrobat.": "Import a document, draw fields on each page and download a fillable PDF.",
  "Chạy trên thiết bị": "Runs on your device",
  "Công cụ tạo form": "Form tools",
  "{0} trang · {1} trường": "{0} pages · {1} fields",
  "Chọn một file để bắt đầu": "Choose a file to get started",
  "Loại trường": "Field type",
  "Chọn loại rồi kéo trên trang để tạo khung.": "Choose a type, then drag on the page to draw a field.",
  "Tên trường đang chọn": "Selected field name",
  "Ví dụ: full_name": "Example: full_name",
  "Chọn một trường để đổi tên": "Select a field to rename it",
  "Xóa trường này": "Delete this field",
  "Xóa {0} trường đã chọn": "Delete {0} selected fields",
  "Tên trường không được trùng; tên trùng sẽ tự thêm số thứ tự.": "Field names must be unique. Duplicate names receive a numbered suffix.",
  "Đổi tên hàng loạt": "Batch rename",
  "trường đã chọn": "selected fields",
  "Tiền tố": "Prefix",
  "Ví dụ: product_": "Example: product_",
  "Bắt đầu từ": "Start at",
  "Thứ tự đánh số": "Numbering order",
  "Trái qua phải, từ trên xuống dưới": "Left to right, top to bottom",
  "Trên xuống dưới, từ trái qua phải": "Top to bottom, left to right",
  "Mẫu:": "Example:",
  ", sau đó tăng dần theo thứ tự đã chọn.": ", then increment in the selected order.",
  "Áp dụng tên hàng loạt": "Apply batch names",
  "Trường đã tạo": "Created fields",
  "Tải PDF form": "Download fillable PDF",
  "Trang PDF để đặt trường form": "PDF page for placing form fields",
  "Khu vực làm việc": "Workspace",
  "Kéo để vẽ · Ctrl + kéo để quét chọn · lăn chuột để zoom": "Drag to draw · Ctrl + drag to select · scroll to zoom",
  "Chưa có PDF được chọn": "No PDF selected",
  "Định dạng {0} trường văn bản": "Format {0} text fields",
  "Phông chữ": "Font",
  "Cỡ chữ": "Font size",
  "Căn chữ": "Text alignment",
  "Căn chữ trái": "Align text left",
  "Căn chữ giữa": "Align text center",
  "Căn chữ phải": "Align text right",
  "Căn chỉnh trường đã chọn": "Align selected fields",
  "Căn trái": "Align left",
  "Căn giữa": "Align center",
  "Căn phải": "Align right",
  "Căn trên": "Align top",
  "Căn giữa dọc": "Align middle",
  "Căn dưới": "Align bottom",
  "Canh đều ngang": "Distribute horizontally",
  "Canh đều dọc": "Distribute vertically",
  "{0} (cần ít nhất 3 trường)": "{0} (at least 3 fields required)",
  "Trang trước": "Previous page",
  "Thu phóng": "Zoom",
  "Thu nhỏ": "Zoom out",
  "Phóng to": "Zoom in",
  "Thả PDF vào đây": "Drop a PDF here",
  "hoặc bấm để chọn file từ thiết bị": "or click to choose a file from your device",
  "Danh sách trường form": "Form field list",
  "LỚP & TRƯỜNG": "LAYERS & FIELDS",
  "trường": "fields",
  "Chọn trang": "Select page",
  "Chưa có trường nào. Kéo trên trang PDF để thêm.": "No fields yet. Drag on the PDF page to add one.",
  "Ctrl + kéo để quét chọn": "Ctrl + drag to select",
  "Ctrl + C / Ctrl + V để nhân bản": "Ctrl + C / Ctrl + V to duplicate",
  "Ctrl + Z để hoàn tác": "Ctrl + Z to undo",
  "Delete để xóa": "Delete to remove",
  "Thiết lập GIF không hợp lệ.": "Invalid GIF settings.",
  "Khung hình hoặc thời gian không hợp lệ.": "Invalid frame or duration.",
  "Chưa có khung hình.": "No frames yet.",
  "Tối đa 80 ảnh. Hãy chọn ít ảnh hơn.": "Up to 80 images. Please choose fewer images.",
  "Không đọc được ảnh.": "Unable to read this image.",
  "Chọn một video mỗi lần.": "Choose one video at a time.",
  "Không mở được tệp.": "Unable to open file.",
  "Thêm video trước khi tạo GIF.": "Add a video before creating a GIF.",
  "Thêm ít nhất 2 ảnh để tạo ảnh động.": "Add at least 2 images to create an animation.",
  "Không tạo được GIF.": "Unable to create GIF.",
  "Chưa có tệp": "No file yet",
  "Sắp xếp từng khoảnh khắc thành một ảnh động.": "Arrange your moments into an animation.",
  "Chọn đoạn bạn muốn giữ, tạo GIF và chia sẻ.": "Choose a clip, create a GIF and share it.",
  "Tệp được xử lý trên thiết bị": "Files are processed on your device",
  "Thiết lập GIF": "GIF settings",
  "Thêm ảnh": "Add images",
  "Thêm video": "Add video",
  "Chọn ảnh tạo GIF": "Choose images for GIF",
  "Chọn video tạo GIF": "Choose video for GIF",
  "Đang đọc tệp…": "Reading files…",
  "Chọn hoặc thả ảnh vào đây": "Choose or drop images here",
  "Chọn hoặc thả video vào đây": "Choose or drop a video here",
  "JPG, PNG, WebP, BMP · tối đa 80 ảnh": "JPG, PNG, WebP, BMP · up to 80 images",
  "Video trình duyệt đọc được · tối đa 150 MB": "Browser-supported video · up to 150 MB",
  "ảnh ·": "images ·",
  "giây": "seconds",
  "Xóa tất cả": "Clear all",
  "Xem ảnh {0}: {1}": "Preview image {0}: {1}",
  "Thời gian": "Time",
  "Thời gian ảnh {0} (ms)": "Image {0} duration (ms)",
  "Đưa ảnh {0} lên": "Move image {0} up",
  "Đưa ảnh {0} xuống": "Move image {0} down",
  "Xóa ảnh {0}": "Remove image {0}",
  "2. Chuyển động": "2. Motion",
  "Thời gian mặc định (ms)": "Default duration (ms)",
  "Thời gian phải từ 20 đến 10.000 ms.": "Duration must be between 20 and 10,000 ms.",
  "Áp dụng tất cả": "Apply to all",
  "300 ms ≈ 3 ảnh/giây. Dùng nút ↑ ↓ để đổi thứ tự.": "300 ms ≈ 3 frames/second. Use ↑ ↓ to reorder.",
  "Bắt đầu (giây)": "Start (seconds)",
  "Kết thúc (giây)": "End (seconds)",
  "Khung hình mỗi giây": "Frames per second",
  "5 FPS · nhẹ": "5 FPS · smaller file",
  "10 FPS · cân bằng": "10 FPS · balanced",
  "15 FPS · mượt": "15 FPS · smooth",
  "24 FPS · mượt hơn": "24 FPS · smoother",
  "Chọn đoạn tối đa 20 giây / 240 frame. GIF không có âm thanh.": "Choose up to 20 seconds / 240 frames. GIFs have no audio.",
  "3. Kích thước & chất lượng": "3. Size & quality",
  "Cạnh dài tối đa": "Maximum long edge",
  "Bảng màu": "Color palette",
  "64 màu · nhẹ": "64 colors · smaller file",
  "128 màu": "128 colors",
  "256 màu · tốt nhất": "256 colors · best quality",
  "Phát lại": "Playback",
  "Lặp vô hạn": "Loop forever",
  "Một lần": "Once",
  "Đặt ảnh": "Image fit",
  "Vừa khung": "Contain",
  "Lấp đầy khung": "Cover",
  "Giữ tỷ lệ ảnh đầu tiên. Vùng trong suốt được ghép lên màu nền đã chọn.": "Keep the first image's aspect ratio. Transparency is composited onto the selected background color.",
  "Đang tạo: {0}/{1} frame": "Creating: {0}/{1} frames",
  "Đang chuẩn bị…": "Preparing…",
  "Hủy tạo GIF": "Cancel GIF creation",
  "Tạo GIF": "Create GIF",
  "GIF đã tạo": "Created GIF",
  "Ảnh của bạn, chuyển động của bạn": "Your images, your animation",
  "Biến khoảnh khắc thành GIF": "Turn a moment into a GIF",
  "Thêm ít nhất 2 ảnh để bắt đầu.": "Add at least 2 images to get started.",
  "Thêm video rồi chọn điểm bắt đầu và kết thúc.": "Add a video, then choose its start and end points.",
  "Đây là file GIF đã mã hóa.": "This is the encoded GIF file.",
  "Tải GIF xuống": "Download GIF",
  "{0} giây · {1} màu": "{0} seconds · {1} colors",
  "Kết quả sẽ xuất hiện tại đây": "Your result will appear here",
  "Bấm Tạo GIF để xem đúng kết quả xuất.": "Select Create GIF to preview the exported result.",
  "Ảnh và video không được tải lên máy chủ.": "Images and videos are not uploaded to a server.",
  "Dừng xem thử": "Stop preview",
  "Phát thử": "Play preview",
  "Quay lại ảnh / video nguồn": "Back to source images / video",
  "Đã hủy tạo GIF.": "GIF creation cancelled.",
  "Không đọc được video. Thử MP4 (H.264) hoặc WebM khác.": "Unable to read video. Try another MP4 (H.264) or WebM file.",
  "Video tối đa 150 MB.": "Videos must be no larger than 150 MB.",
  "Video không có thời lượng hợp lệ.": "The video has no valid duration.",
  ": dùng JPG, PNG, WebP hoặc BMP, tối đa 20 MB/ảnh.": ": use JPG, PNG, WebP or BMP, up to 20 MB per image.",
  ": ảnh quá lớn (tối đa 40 megapixel).": ": image is too large (up to 40 megapixels).",
  "Thêm ảnh trước khi tạo GIF.": "Add images before creating a GIF.",
  "Thời gian mỗi ảnh phải từ 20 đến 10.000 ms.": "Each frame must last between 20 and 10,000 ms.",
  "Xử lý quá lâu. Hãy giảm kích thước GIF và thử lại.": "Processing timed out. Reduce the GIF dimensions and try again.",
  "Không tải được bộ tạo GIF. Tải lại trang rồi thử lại.": "Unable to load the GIF encoder. Reload the page and try again.",
  "Trình duyệt không hỗ trợ Canvas.": "Your browser does not support Canvas.",
  "Không nhận được GIF.": "No GIF was received.",
  "Kích thước không hợp lệ.": "Invalid dimensions.",
  "Chọn đoạn từ 0–20 giây trong video và FPS từ 1–24.": "Choose a 0–20 second clip and a frame rate of 1–24 FPS.",
  "Tối đa 240 khung hình. Hãy giảm FPS hoặc rút ngắn đoạn video.": "Up to 240 frames. Reduce the frame rate or shorten the clip.",
  "Kích thước GIF phải từ 1 đến 960 pixel.": "GIF dimensions must be between 1 and 960 pixels.",
  "GIF này quá lớn. Hãy giảm kích thước, số ảnh hoặc FPS (tối đa 40 triệu pixel cho toàn bộ GIF).": "This GIF is too large. Reduce dimensions, images or FPS (40 million pixels total maximum).",
  "Chưa khởi tạo GIF.": "GIF encoder is not initialized.",
  "Yêu cầu không hợp lệ.": "Invalid request.",
  "Dữ liệu ảnh không hợp lệ.": "Invalid image data.",
  "ICO tối đa 256 × 256 px.": "ICO dimensions are limited to 256 × 256 px.",
  "Không có ảnh để tải.": "No images to download.",
  "Kết quả vượt 250 MB. Hãy chuyển ít ảnh hơn mỗi lần.": "Output exceeds 250 MB. Convert fewer images at a time.",
  "Tên kết quả bị trùng.": "Duplicate output names.",
  "Ảnh tối đa 40 megapixel, mỗi cạnh tối đa 32.767 px.": "Images are limited to 40 megapixels and 32,767 px per side.",
  "Hãy thêm ít nhất một ảnh.": "Add at least one image.",
  "Tối đa 50 ảnh mỗi lần.": "Up to 50 images at a time.",
  ": định dạng ảnh chưa được hỗ trợ.": ": unsupported image format.",
  ": khác định dạng From đã chọn. Chọn Tự nhận diện để dùng ảnh nhiều loại.": ": does not match the selected From format. Select Auto to use mixed formats.",
  ": file phải có dữ liệu và không quá 40 MB.": ": file must contain data and be no larger than 40 MB.",
  "Tổng ảnh tối đa 150 MB mỗi lần.": "Images are limited to 150 MB per batch.",
  "Không thể thêm ảnh.": "Unable to add images.",
  "Đã tạo ZIP chứa": "Created a ZIP containing",
  "ảnh.": "images.",
  "Đã tạo": "Created",
  "Không thể chuyển ảnh.": "Unable to convert images.",
  "SVG giữ vector gốc; ảnh raster sẽ được nhúng.": "SVG keeps the original vectors; raster images are embedded.",
  "ICO tối đa 256 px · nhiều ảnh tải trong ZIP.": "ICO is limited to 256 px · multiple images download as a ZIP.",
  "Vùng trong suốt thành nền trắng · nhiều ảnh tải ZIP.": "Transparency becomes white · multiple images download as a ZIP.",
  "Một ảnh tải trực tiếp · nhiều ảnh tải trong ZIP.": "One image downloads directly · multiple images download as a ZIP.",
  "Đang nén ZIP…": "Packing ZIP…",
  "Đang chuyển": "Converting",
  "ảnh…": "images…",
  "Chọn ảnh để chuyển đổi": "Choose images to convert",
  "Ảnh đã chọn": "Selected images",
  "Xóa ảnh": "Remove image",
  "+ Thêm ảnh": "+ Add images",
  "/50 ảnh": "/50 images",
  "Đổi định dạng: lấy khung / trang đầu.": "Format conversion uses the first frame / page.",
  "Định dạng ảnh nguồn": "Source image format",
  "Định dạng ảnh xuất": "Output image format",
  "Nén ZIP…": "Packing ZIP…",
  "Không thể đổi kích thước ảnh.": "Unable to resize images.",
  "Nhập Rộng hoặc Cao · cạnh còn lại tự tính theo từng ảnh.": "Enter width or height · the other side is calculated per image.",
  "Giữ tỷ lệ, căn giữa · JPG thêm nền trắng.": "Keep proportions, center image · JPG adds a white background.",
  "Giữ tỷ lệ, căn giữa · nhiều ảnh tải một ZIP.": "Keep proportions, center image · multiple images download as a ZIP.",
  "Đang resize": "Resizing",
  "Chọn ảnh để đổi kích thước": "Choose images to resize",
  "Ảnh chờ resize": "Images to resize",
  "Xóa ảnh resize": "Remove resize image",
  "Resize: lấy khung / trang đầu.": "Resizing uses the first frame / page.",
  "Đổi kích thước hàng loạt": "Batch resize images",
  "Scale theo một cạnh · không thêm phần dư": "Scale one side · no padding",
  "Giữ tỷ lệ · thêm phần dư · không kéo méo": "Keep proportions · add padding · no stretching",
  "Rộng (px)": "Width (px)",
  "Chiều rộng (px)": "Width (px)",
  "Chiều cao (px)": "Height (px)",
  "Định dạng": "Format",
  "Định dạng ảnh resize": "Resized image format",
  "Đã hủy chuyển ảnh.": "Image conversion cancelled.",
  ": không đọc được SVG.": ": unable to read SVG.",
  "Không khởi tạo được Canvas.": "Unable to initialize Canvas.",
  "Không đọc được SVG.": "Unable to read SVG.",
  "Xử lý quá lâu. Hãy chuyển ít ảnh hơn.": "Processing timed out. Convert fewer images.",
  "Không tải được bộ chuyển ảnh. Tải lại trang rồi thử lại.": "Unable to load the image converter. Reload the page and try again.",
  "Chọn chiều rộng hoặc chiều cao để scale.": "Choose width or height to scale.",
  "Nhập một cạnh bằng số nguyên lớn hơn 0.": "Enter a positive whole number for one side.",
  "Chiều rộng và chiều cao phải là số nguyên lớn hơn 0.": "Width and height must be positive whole numbers.",
  "Chế độ resize không hợp lệ.": "Invalid resize mode.",
  "Không tải được bộ đọc HEIC.": "Unable to load the HEIC reader.",
  "Không đọc được ảnh HEIC.": "Unable to read HEIC image.",
  "Không giải mã được ảnh HEIC.": "Unable to decode HEIC image.",
  "Không đọc được TIFF.": "Unable to read TIFF.",
  "Trình duyệt không xuất được": "Your browser cannot export",
  "Định dạng đầu ra không hợp lệ.": "Invalid output format.",
  "Resize hỗ trợ xuất PNG, JPG và WebP.": "Resize supports PNG, JPG and WebP output.",
  "Kết quả ảnh không có dữ liệu.": "The output image contains no data.",
  "Nhập 12 chữ số – check digit cuối tự động tính.": "Enter 12 digits – the final check digit is calculated automatically.",
  "Nhập 11 chữ số – check digit cuối tự động tính.": "Enter 11 digits – the final check digit is calculated automatically.",
  "Nhập 13 chữ số – check digit cuối tự động tính.": "Enter 13 digits – the final check digit is calculated automatically.",
  "Nhập chuỗi bất kỳ – check digit tự động tính.": "Enter any text – the check digit is calculated automatically.",
  "Nhập AI trong ngoặc đơn, không có khoảng trắng.": "Enter AIs in parentheses, without spaces.",
  "Nhập văn bản, URL, số điện thoại…": "Enter text, a URL, a phone number…",
  "{0} cần đủ {1} chữ số.": "{0} requires {1} digits.",
  "Vui lòng nhập {0}.": "Please enter {0}.",
  "EAN-13 cần đúng 13 chữ số.": "EAN-13 requires exactly 13 digits.",
  "UPC-A cần đúng 12 chữ số.": "UPC-A requires exactly 12 digits.",
  "ITF-14 cần đúng 14 chữ số.": "ITF-14 requires exactly 14 digits.",
  "Chuỗi GS1-128 không hợp lệ hoặc chứa AI không nhận dạng được.": "Invalid GS1-128 data or an unrecognized AI.",
  "Chuỗi GS1-128 không hợp lệ.": "Invalid GS1-128 data.",
  "Vui lòng nhập ít nhất một mã.": "Please enter at least one code.",
  "Trình duyệt không hỗ trợ xuất canvas.": "Your browser does not support canvas export.",
  "Không thể tạo file PNG.": "Unable to create PNG file.",
  "Không thể chuyển mã sang PNG.": "Unable to convert the barcode to PNG.",
  "AdSense không phản hồi.": "AdSense did not respond.",
  "Không tải được AdSense.": "Unable to load AdSense.",
  "trái": "left",
  "phải": "right",
  "Quảng cáo bên {0}": "Advertisement on the {0}",
  "Quảng cáo": "Ads",
  "Hiện chưa có quảng cáo.": "No advertisement is available right now.",
  "Không gian": "Advertising",
  "quảng cáo": "space",
  "Bản xem trước": "Preview",
  "Cấu hình quảng cáo phải là một object.": "Advertising configuration must be an object.",
  "Chế độ quảng cáo không hợp lệ.": "Invalid advertising mode.",
  "Publisher ID AdSense phải có dạng ca-pub- và 16 chữ số.": "AdSense publisher ID must start with ca-pub- followed by 16 digits.",
  "Cần mã ad slot hợp lệ cho cả banner trái và phải.": "Valid ad slot IDs are required for both left and right banners.",
  "Cần danh sách hostname production, không gồm giao thức, đường dẫn hoặc ký tự đại diện.": "Production hostnames must not include protocols, paths or wildcards.",
  "Xóa": "Delete",
  "Xoay (Shift: bước 10°)": "Rotate (Shift: 10° steps)",
  "Chỉnh lại Smart Text · Ctrl+click: chuyển sang bản vá raster": "Edit Smart Text · Ctrl+click: switch to a raster patch",
  "Chỉnh lại Smart Text · Ctrl+click: chuyển sang chữ vector": "Edit Smart Text · Ctrl+click: switch to vector text",
  "Vui lòng kéo thả file PDF đầu tiên.": "Please drop a PDF file first.",
  "Lỗi file PDF:": "PDF file error:",
  "Chưa có trang được chọn": "No page selected",
  "Thêm một tệp PDF, sau đó chọn trang ở bảng bên trái để bắt đầu chỉnh sửa.": "Add a PDF file, then select a page in the left panel to start editing.",
  "Tiếng Việt": "Vietnamese",
  "Không thể đọc ảnh của lớp chỉnh sửa.": "Unable to read the editing layer image.",
  "Dữ liệu ảnh chỉnh sửa không hợp lệ.": "Invalid editing image data.",
  "Không tải được font vector {0}.": "Unable to load vector font {0}.",
  "Google Fonts không trả về file font cho {0}.": "Google Fonts returned no font file for {0}.",
  "Không tải được dữ liệu font {0}.": "Unable to load font data for {0}.",
  "Fontkit chưa sẵn sàng để nhúng font vector.": "Fontkit is not ready to embed vector fonts.",
  "Trình duyệt không thể xoay ảnh chữ khi xuất PDF.": "Your browser cannot rotate the text image during PDF export.",
  "Lỗi crop:": "Crop error:",
  "Lỗi khi vẽ Text": "Error drawing text",
  "Lỗi khi vẽ Image": "Error drawing image",
  "Lỗi khi vẽ Shape": "Error drawing shape",
  "Không thể tạo ảnh cho trang PDF.": "Unable to create an image of the PDF page.",
  "Trang {0} ở {1} PPI vượt giới hạn ảnh của trình duyệt ({2} × {3}px).": "Page {0} at {1} PPI exceeds the browser image limit ({2} × {3}px).",
  "Trình duyệt không thể tạo canvas để gộp trang.": "Your browser cannot create a canvas for flattened pages.",
  "Chưa có trang nào.": "No pages yet.",
  "Vui lòng chọn một trang để export.": "Please select a page to export.",
  "Lỗi xuất ảnh:": "Image export error:",
  "Font hệ thống": "System font",
  "Không tải được bộ OCR.": "Unable to load the OCR engine.",
  "Không tách được nét chữ trong vùng chọn.": "Unable to isolate text strokes in the selection.",
  "Đang tải font ứng viên…": "Loading candidate fonts…",
  "Đang so khớp hình dáng chữ…": "Matching character shapes…",
  "Đang đọc text trong PDF…": "Reading text in PDF…",
  "Không có text layer, đang OCR vùng chọn…": "No text layer found. Running OCR on the selection…",
  "Đã nhận diện xong": "Recognition complete",
  "Không đủ nét chữ để phân tích hiệu ứng scan.": "Not enough text detail to analyze scan effects.",
  "Vui lòng chọn một trang trước.": "Please select a page first.",
  "Nhập text tại đây": "Enter text here",
  "Xuất PDF": "Export PDF",
  "Đang gộp trang…": "Flattening pages…",
  "Lỗi:": "Error:",
  "Chưa chọn trang": "No page selected",
  "Đối tượng đang chọn": "Selected object",
  "Dùng thanh thuộc tính phía trên canvas": "Use the properties toolbar above the canvas",
  "{0} trang trong tài liệu": "{0} pages in this document",
  "Thêm PDF để bắt đầu": "Add a PDF to get started",
  "Bấm vào dấu cộng để thêm ảnh hoặc kéo thả ảnh vào khu vực của Combine image to PDF (Định dạng chấp nhận là: PNG, JPG, JPEG, TIFF, WEBP).": "Select the plus button or drop images into Combine images to PDF. Supported formats: PNG, JPG, JPEG, TIFF and WEBP.",
  "Có thể kéo thả hình trong khu vực danh sách để thay đổi thứ tự.": "Drag images in the list to reorder them.",
  "Thay đổi cỡ giấy xuất ra (Fit to image, A4 Vertical, A4 Horizontal).": "Change the output page size: Fit to image, A4 portrait or A4 landscape.",
  "Giảm chất lượng ảnh để giảm dung lượng file.": "Reduce image quality to make the file smaller.",
  "Giữ nguyên chất lượng gốc.": "Keep the original quality.",
  "Nén hình trung bình (Khuyên dùng, rất nhẹ, đủ view).": "Medium image compression: recommended for a small, readable file.",
  "Nén mạnh, file rất nhẹ nhưng mờ (tùy trường hợp áp dụng).": "Strong compression: smaller files with reduced clarity.",
  "Bấm": "Select",
  "để tải file về.": "to download the file.",
  "Bấm vào dấu cộng để thêm file PDF hoặc kéo thả PDF vào khu vực của Merge PDFs.": "Select the plus button or drop PDF files into Merge PDFs.",
  "Có thể kéo thả file trong khu vực danh sách để thay đổi thứ tự ghép.": "Drag files in the list to change their merge order.",
  "Giảm dung lượng file PDF.": "Reduce the PDF file size.",
  "Nén trung bình (Khuyên dùng).": "Medium compression (recommended).",
  "Nén mạnh.": "Strong compression.",
  "Bấm vào dấu cộng để thêm file PDF, hoặc kéo thả PDF vào.": "Select the plus button or drop a PDF file here.",
  "Sau khi add PDF, có thể kéo thêm hình hoặc file PDF khác vào tiếp trong khu vực Edit PDF.": "After adding a PDF, you can keep dropping images or other PDFs into Edit PDF.",
  "Nhấn dấu": "Select",
  "ở góc trên trang để xóa trang nào không cần.": "in the page corner to remove an unwanted page.",
  "Có thể kéo thả để thay đổi vị trí các trang.": "Drag pages to reorder them.",
  "Xuất trang PDF đang chọn ra thành hình ảnh (Page), hoặc xuất toàn bộ (All).": "Export the selected PDF page as an image (Page), or export every page (All).",
  "Click chọn 1 trang": "Select a page",
  "trong danh sách để bắt đầu Edit ở khung bên phải:": "in the list to start editing it in the right panel:",
  "Thêm chữ, thay đổi font, type, cỡ chữ bên khu vực edit bên trên.": "Add text, then adjust its font, style and size in the toolbar above.",
  "Add Image (Icon hình ảnh):": "Add Image (image icon):",
  "Thêm hình ảnh.": "Add an image.",
  "Mẹo:": "Tip:",
  "Nhấn giữ phím": "Hold",
  "+ click Add Image để thêm hình ảnh và làm mờ viền (dùng để hòa trộn hình ảnh với nền).": "and select Add Image to soften the image edges and blend it into the background.",
  "Shape (Icon hình khối):": "Shape (shape icon):",
  "Chọn button shape để vẽ.": "Select the shape button to draw.",
  "Nhấn": "Press",
  "để đổi mode vẽ (Ví dụ: vuông/elip/tam giác).": "to change the shape type: rectangle, ellipse or triangle.",
  "Nhấn giữ": "Hold",
  "+ kéo chuột để vẽ hình vuông đều, tam giác đều hoặc hình tròn.": "and drag to draw a square, equilateral triangle or circle.",
  "Line (Icon đường kẻ):": "Line (line icon):",
  "để đổi thành vẽ line mũi tên.": "to switch to an arrow.",
  "+ kéo chuột để vẽ đường thẳng vuông góc hoặc chéo 45 độ.": "and drag to draw a horizontal, vertical or 45° line.",
  "Thay Chữ Nâng Cao (Icon bút tím):": "Advanced Text Replacement (purple pen icon):",
  "Khoanh vùng chữ cũ để hệ thống nhận diện nội dung, font và hiệu ứng scan, sau đó nhập chữ mới để thay thế.": "Select the old text to recognize its content, font and scan effects, then enter replacement text.",
  "Phóng to/Thu nhỏ (Zoom):": "Zoom in/out:",
  "Giữ phím": "Hold",
  "+ Lăn chuột giữa (Mouse Wheel) tại khu vực màn hình Edit bên phải để zoom nhanh và tập trung vào vị trí con trỏ chuột.": "and scroll in the right editing area to zoom around the pointer.",
  "Khu vực Bottom (Dưới cùng):": "Bottom toolbar:",
  "Để chuyển đổi size giấy của trang.": "Change the page size.",
  "Xoay trang theo góc 90°.": "Rotate the page in 90° steps.",
  "Để cắt xén kích thước trang.": "Crop the page.",
  "Khi tick vào đây và thao tác 1 chức năng trong khu vực bottom này (size, rotate, crop) thì sẽ": "When enabled, changes to page size, rotation or crop will",
  "áp dụng cho tất cả các trang": "apply to all pages",
  "Thay Chữ Nâng Cao": "Advanced Text Replacement",
  "Tạo vùng chọn:": "Create a selection:",
  "Chọn công cụ Thay Chữ Nâng Cao rồi kéo khoanh sát khu vực text cần xử lý. Nên zoom lớn trước khi khoanh để lấy đủ chiều cao nét chữ và hạn chế dính nội dung xung quanh.": "Select Advanced Text Replacement, then draw a close selection around the text. Zoom in first to include complete character strokes and avoid nearby content.",
  "Nhận diện tự động:": "Automatic recognition:",
  "Hệ thống đọc chữ gốc, PPI của trang, tìm font tương đồng và phân tích đặc điểm của bản scan.": "The editor reads the original text and page PPI, finds a similar font and analyzes scan characteristics.",
  "Chọn font:": "Choose a font:",
  "Font được đề xuất sẽ tự hiển thị. Có thể giữ font đề xuất hoặc chọn font khác trong thư viện, sau đó điều chỉnh kiểu chữ, độ đậm, màu và cỡ chữ nếu cần.": "Keep the suggested font or choose another from the library, then adjust its style, weight, color and size if needed.",
  "Khớp hiệu ứng:": "Match effects:",
  "Các thông số như Blur, Sharpen, mức loang, Contrast, Noise, JPEG và Smart sharpen cũng được đề xuất theo vùng scan. Có thể dùng ngay kết quả nhận diện hoặc chuyển sang Tùy chỉnh để kéo từng slider cho giống tài liệu gốc hơn.": "Blur, sharpen, spread, contrast, noise, JPEG and Smart Sharpen settings are suggested from the scan. Use the detected settings or select Custom to adjust the sliders against the original.",
  "Hoàn tất:": "Finish:",
  "Kiểm tra kết quả trong khung xem trước rồi bấm": "Check the preview, then select",
  "Thay Chữ": "Replace Text",
  ". Khi chọn lại object, bấm nút chỉnh sửa để mở lại toàn bộ font và hiệu ứng đã lưu.": ". Select the object again and use Edit to reopen its saved font and effects.",
  "Lưu ý:": "Note:",
  "Kết quả nhận diện là điểm bắt đầu. Với bản scan mờ, nhiễu hoặc font hiếm, hãy thử font gần nhất trong thư viện và tinh chỉnh hiệu ứng bằng mắt trong khung xem trước.": "Recognition provides a starting point. For blurry or noisy scans and unusual fonts, try the closest library font and adjust effects visually in the preview.",
  "Nội dung hướng dẫn đang được cập nhật.": "This guide is being updated.",
  "Không thể tải hướng dẫn PDF Editor.": "Unable to load the PDF Editor guide.",
  "Không thể tải hướng dẫn. Vui lòng thử lại.": "Unable to load the guide. Please try again.",
  "Kiểu kết quả": "Output type",
  "Bản vá ảnh · hợp với scan": "Image patch · best for scans",
  "Chữ vector · hợp với PDF text": "Vector text · best for text PDFs",
  "Đang chuẩn bị nhận diện font…": "Preparing font recognition…",
  "Chữ gốc": "Original text",
  "Dò lại": "Detect again",
  "Nhập chữ mới bạn muốn chèn vào bản scan": "Enter the new text to insert into the scan",
  "Thường": "Regular",
  "Đậm": "Bold",
  "Thẳng": "Normal",
  "Nghiêng": "Italic",
  "Cỡ Chữ (Size):": "Font size:",
  "Hiệu ứng chữ": "Text effects",
  "Khớp tài liệu scan": "Match scanned document",
  "Chữ kỹ thuật số sạch": "Clean digital text",
  "Tùy chỉnh": "Custom",
  "Đang phân tích hiệu ứng scan…": "Analyzing scan effects…",
  "Cường độ": "Intensity",
  "Mực loang": "Ink spread",
  "Bản xem trước sẽ hiện ở đây...": "Your preview will appear here...",
  "Tự đọc từ PDF hoặc OCR": "Read from PDF or OCR automatically",
  "Ví dụ: THIẾT KẾ VINUT": "For example: YOUR DESIGN",
  "Màu chữ": "Text color",
  "Tỷ lệ cỡ chữ so với khung chọn": "Font size relative to the selection",
  "Làm nhạt lõi nét và gom mật độ mực về hai mép trong như Photoshop Smart Sharpen": "Lighten the stroke core and concentrate ink along the inner edges, similar to Photoshop Smart Sharpen",
  "Chỉnh Lại Chữ Nâng Cao": "Edit Advanced Text",
  "Sửa Chữ Nâng Cao": "Edit Advanced Text",
  "Cập nhật": "Update",
  "tự nhận diện": "automatically detected",
  "ước tính": "estimated",
  "Vùng chọn: {0} × {1} px canvas · nguồn {2} PPI ({3})": "Selection: {0} × {1} canvas px · source {2} PPI ({3})",
  "Đang dùng font {0} · bấm Dò lại nếu cần": "Using font {0} · select Detect again if needed",
  "Không đủ dữ liệu để khớp tự động; có thể chỉnh tay.": "Not enough data for automatic matching. Adjust manually instead.",
  "Không đọc được chữ gốc — nhập thủ công rồi bấm Dò lại": "Unable to read the original text — enter it manually and select Detect again",
  "Không thể phân tích vùng chọn:": "Unable to analyze the selection:",
  "· {0} vùng trên trang": "· {0} regions on the page",
  "Đã khớp {0}%{1} · blur {2}px · sharpen {3}% · JPEG {4}%": "Matched {0}%{1} · blur {2}px · sharpen {3}% · JPEG {4}%",
  "Không áp hiệu ứng scan.": "No scan effects applied.",
  "{1}% tương đồng": "{1}% similarity",
  "Chữ nhập tay": "Manually entered text",
  "{0} · Gợi ý: {1}": "{0} · Suggested: {1}",
  "Nhập chữ để xem trước...": "Enter text to preview...",
  "Đang dùng profile tùy chỉnh.": "Using a custom profile.",
  "Dò font thất bại:": "Font detection failed:",
  "Đã nạp lại toàn bộ thông số của object hiện tại.": "Restored all settings for the current object.",
  "Nền vẫn được làm sạch; chữ xuất PDF là text vector.": "The background is cleaned; text is exported as vector text.",
  "Chữ và hiệu ứng được hòa vào ảnh nền theo PPI nguồn.": "Text and effects are blended into the background at the source PPI.",
  "⚡ [Smart Canvas] Đang áp dụng Text + Thuật toán đồ họa thủ công...": "⚡ [Smart Canvas] Applying text and graphics processing...",
  "Không thể xử lý vùng chữ. Vui lòng thử lại.": "Unable to process the text area. Please try again.",
  "Trang chưa được render. Vui lòng chọn lại trang.": "Page has not rendered. Please select it again.",
  "Đang cập nhật...": "Updating...",
  "Đang tạo...": "Creating...",
  "Thử lại": "Try again",
  "Lỗi khi đọc file TIFF:": "Error reading TIFF:",
  "Không thể giải mã file TIFF này.": "Unable to decode this TIFF file.",
  "Tệp & trang": "Files & pages",
  "hoặc bấm để chọn từ thiết bị": "or click to choose from your device",
  "XUẤT ẢNH TRANG": "EXPORT PAGE IMAGES",
  "Trang hiện tại": "Current page",
  "Tất cả trang": "All pages",
  "Bản gộp theo hình ảnh": "Flattened image-based PDF",
  "Giữ nội dung chỉnh sửa": "Keep editable content",
  "Kiểu chữ": "Font style",
  "Viền": "Stroke",
  "Khổ giấy": "Page size",
  "Giữ nguyên": "Keep original",
  "A4 dọc": "A4 portrait",
  "A3 dọc": "A3 portrait",
  "Cắt trang": "Crop page",
  "Thông tin trang": "Page information",
  "Hướng dẫn PDF Editor": "PDF Editor guide",
  "Chọn tệp PDF": "Choose PDF file",
  "Không tô nền": "No fill",
  "Không viền": "No stroke",
  "Thêm chữ": "Add text",
  "Thêm ảnh · giữ Ctrl để làm mờ viền": "Add image · hold Ctrl to soften edges",
  "Hình khối · Ctrl để đổi loại": "Shape · Ctrl to change type",
  "Vẽ hình khối": "Draw shape",
  "Đường thẳng hoặc mũi tên · Ctrl để đổi loại": "Line or arrow · Ctrl to change type",
  "Vẽ đường thẳng hoặc mũi tên": "Draw line or arrow",
  "Thay chữ nâng cao — kéo chọn vùng chữ cũ rồi nhập chữ mới": "Advanced text replacement — select the old text and enter new text",
  "Thay chữ nâng cao": "Advanced text replacement",
  "Áp dụng cho tất cả các trang": "Apply to all pages",
  "Thông tin PDF Editor": "PDF Editor information",
  "Đóng hướng dẫn": "Close guide",
  "{0}: dùng JPG, PNG, WebP hoặc BMP, tối đa 20 MB/ảnh.": "{0}: use JPG, PNG, WebP or BMP, up to 20 MB per image.",
  "{0}: ảnh quá lớn (tối đa 40 megapixel).": "{0}: image is too large (up to 40 megapixels).",
  "{0}: định dạng ảnh chưa được hỗ trợ.": "{0}: unsupported image format.",
  "{0}: khác định dạng From đã chọn. Chọn Tự nhận diện để dùng ảnh nhiều loại.": "{0}: does not match the selected From format. Select Auto to use mixed formats.",
  "{0}: file phải có dữ liệu và không quá 40 MB.": "{0}: file must contain data and be no larger than 40 MB.",
  "{0}: không đọc được SVG.": "{0}: unable to read SVG.",
  "Bỏ qua điều hướng": "Skip navigation",
  "Cao (px)": "Height (px)",
  "Trang": "Page",
  "TRANG PDF": "PDF PAGES",
  "A4 ngang": "A4 landscape",
  "A3 ngang": "A3 landscape",
  "Đã tạo ZIP chứa {0} ảnh.": "Created a ZIP containing {0} images.",
  "Đang chuyển {0}/{1} ảnh…": "Converting {0}/{1} images…",
  "Đang chuyển {0}/{1}": "Converting {0}/{1}",
  "Đang resize {0}/{1} ảnh…": "Resizing {0}/{1} images…",
  "Đang resize {0}/{1}": "Resizing {0}/{1}",
  "Xóa ảnh {0}: {1}": "Remove image {0}: {1}",
  "Xóa ảnh resize {0}: {1}": "Remove resize image {0}: {1}",
  "Banner trái": "Left banner",
  "Banner phải": "Right banner",
  "Quảng cáo bên trái": "Left advertisement",
  "Quảng cáo bên phải": "Right advertisement",
  "Không gian quảng cáo": "Advertising space",
  "Trang sau": "Next page",
  "Prompt mẫu dùng tiếng Anh; nội dung bạn nhập không được dịch tự động.": "Templates use English; your entries are not translated automatically.",
  "Trang {0} / {1}": "Page {0} / {1}",
  "Trang {0}": "Page {0}",
  "{0} trang": "{0} pages",
  "{0} ảnh": "{0} images",
  "Cao": "Height",
  "Tìm tài nguyên...": "Search resources...",
  "Tìm tài nguyên": "Search resources",
  "Loại tài nguyên": "Resource categories",
  "Danh sách tài nguyên": "Resource list",
  "Không tìm thấy tài nguyên": "No resources found",
  "Chưa có tài nguyên trong mục này": "No resources in this category yet",
  "Thử từ khóa khác hoặc chọn một mục khác.": "Try another search or choose a different category.",
  "Tài nguyên cho mục này đang được bổ sung. Bạn có thể xem các mục khác trong lúc chờ.": "Resources for this category are being prepared. Explore the other categories in the meantime.",
  "Xem tất cả tài nguyên": "View all resources",
  "DesignForge — công cụ, tài nguyên và prompt cho người làm thiết kế.": "DesignForge — tools, resources and prompts for designers.",
  "Hỗ trợ": "Support",
  "Liên hệ": "Contact",
  "Donate": "Donate",
  "LIÊN HỆ": "CONTACT",
  "ỦNG HỘ": "SUPPORT",
  "Liên hệ DesignForge": "Contact DesignForge",
  "Ủng hộ DesignForge": "Support DesignForge",
  "Gửi ý kiến hoặc yêu cầu": "Send feedback or a request",
  "Bạn cứ mô tả điều muốn góp ý hoặc tính năng cần bổ sung. Mình sẽ đọc và liên hệ lại qua email khi tiếp nhận.": "Describe your feedback or the feature you would like to see. I will read it and get back to you by email after reviewing it.",
  "Mô tả ý kiến / yêu cầu": "Feedback / request",
  "Email của bạn": "Your email",
  "Ví dụ: mình muốn có thêm công cụ...": "For example: I would like another tool...",
  "Nút gửi sẽ mở ứng dụng email của bạn.": "Send opens your email application.",
  "Gửi yêu cầu": "Send request",
  "Đóng": "Close",
  "Đóng hộp thoại liên hệ": "Close contact dialog",
  "Nội dung không được để trống": "Please describe your feedback or request",
  "Email chưa hợp lệ": "Please enter a valid email",
  "Cảm ơn bạn đã sử dụng DesignForge.": "Thank you for using DesignForge.",
  "Mình sẽ cố gắng thật nhiều để cải thiện website. Niềm vui của mình là thấy bạn ghé thăm và sử dụng những công cụ này mỗi ngày. Chúc bạn luôn nhiều năng lượng, công việc thuận lợi và thật khỏe mạnh.": "I will keep working hard to improve this website. It makes me happy to see you visit and use these tools every day. I wish you energy, smooth work and good health.",
  "Nếu DesignForge giúp bạn tiết kiệm được một chút thời gian, bạn có thể ủng hộ vibe coder lỏ này một gói mì tôm chống đói để tiếp tục phát triển web nhé. Một lời cảm ơn của bạn cũng đã là động lực rất lớn rồi!": "If DesignForge saves you a little time, you can support this scrappy vibe coder with a small meal so I can keep building the site. Even a kind thank-you is already a huge motivation!",
  "Hiện thông tin chuyển khoản": "Show transfer details",
  "Ẩn thông tin chuyển khoản": "Hide transfer details",
  "Thông tin chuyển khoản sẽ được cập nhật": "Transfer details will be added soon",
  "Ngân hàng": "Bank",
  "Chủ tài khoản": "Account name",
  "Số tài khoản": "Account number",
  "Nội dung chuyển khoản": "Transfer note",
  "Đóng hộp thoại Donate": "Close donation dialog",
  "Email liên hệ": "Contact email",
  "Về website DesignForge": "Back to DesignForge",
  "Về website": "Open website",
  "Điều hướng quản trị": "Admin navigation",
  "KHU VỰC QUẢN TRỊ": "ADMIN AREA",
  "Quản lý DesignForge": "Manage DesignForge",
  "Dữ liệu sẽ kết nối sau": "Data will connect later",
  "Chủ website": "Site owner",
  "Tùy chọn tài khoản": "Account options",
  "ADMIN CONSOLE": "ADMIN CONSOLE",
  "Trung tâm quản trị": "Admin center",
  "Theo dõi hoạt động, nội dung và tín hiệu tăng trưởng của DesignForge ở một nơi.": "Track activity, content and growth signals for DesignForge in one place.",
  "Khoảng thời gian": "Time range",
  "Hôm nay": "Today",
  "Tháng này": "This month",
  "Quý này": "This quarter",
  "Năm nay": "This year",
  "Bản dựng giao diện": "UI preview build",
  "Số liệu hiện đang là dữ liệu minh họa để hoàn thiện bố cục. Chưa kết nối analytics, tải xuống, yêu cầu hay doanh thu thật.": "These figures are illustrative data for the layout. Analytics, downloads, requests and real revenue are not connected yet.",
  "CHỜ KẾT NỐI": "WAITING FOR CONNECTION",
  "Lượt truy cập": "Visits",
  "Người dùng hợp lệ": "Human visitors",
  "Lượt tải xuống": "Downloads",
  "Yêu cầu đang chờ": "Open requests",
  "+18,4% so với kỳ trước": "+18.4% vs previous period",
  "64,1% traffic mẫu": "64.1% sample traffic",
  "42 lượt bị chặn mẫu": "42 sample blocks",
  "4 yêu cầu cần xử lý": "4 requests need review",
  "MẪU": "SAMPLE",
  "TRAFFIC": "TRAFFIC",
  "Người thật và bot": "Humans and bots",
  "Dữ liệu mẫu": "Sample data",
  "Mẫu traffic: 64% người dùng hợp lệ, 36% bot": "Sample traffic: 64% human visitors, 36% bots",
  "người thật": "human visitors",
  "Bot / crawler": "Bots / crawlers",
  "Khi kết nối, hệ thống sẽ dùng user agent, rate limit và dấu hiệu hành vi để phân loại.": "When connected, the system will use user agents, rate limits and behavior signals to classify traffic.",
  "Biểu đồ traffic theo ngày": "Traffic chart by day",
  "XẾP HẠNG": "RANKING",
  "Công cụ được dùng nhiều": "Most used tools",
  "Chi tiết": "Details",
  "Converter": "Converter",
  "PDF": "PDF",
  "GIF": "GIF",
  "Xem bảo mật": "View security",
  "Mở danh sách": "Open list",
  "Thu nhập dự kiến": "Estimated income",
  "Xem thu nhập": "View income",
  "TRAFFIC VOLUME": "TRAFFIC VOLUME",
  "Lượt truy cập · Hôm nay": "Visits · Today",
  "Lượt truy cập · Tháng này": "Visits · This month",
  "Lượt truy cập · Quý này": "Visits · This quarter",
  "Lượt truy cập · Năm nay": "Visits · This year",
  "BẢO MẬT": "SECURITY",
  "Lớp kiểm tra sẽ kết nối": "Checks to connect",
  "Chờ kết nối": "Pending connection",
  "Rate limit theo IP": "IP rate limiting",
  "Chặn burst tải bất thường": "Block abnormal download bursts",
  "Phân loại user agent": "User agent classification",
  "Nhận diện crawler phổ biến": "Identify common crawlers",
  "Đối chiếu hành vi": "Behavior matching",
  "Tách session người thật": "Separate human sessions",
  "Cảnh báo chi phí": "Cost alerts",
  "Báo sớm traffic tăng đột biến": "Early warning for traffic spikes",
  "TOOL USAGE": "TOOL USAGE",
  "Xếp hạng chức năng": "Feature ranking",
  "Theo dõi công cụ được dùng nhiều nhất theo ngày, tháng, quý hoặc năm.": "Track the most used tools by day, month, quarter or year.",
  "BẢNG XẾP HẠNG": "RANKING TABLE",
  "Top chức năng · Hôm nay": "Top features · Today",
  "Top chức năng · Tháng này": "Top features · This month",
  "Top chức năng · Quý này": "Top features · This quarter",
  "Top chức năng · Năm nay": "Top features · This year",
  "Chức năng": "Feature",
  "Nhóm": "Group",
  "Lượt dùng": "Uses",
  "Tỷ trọng": "Share",
  "DOWNLOADS": "DOWNLOADS",
  "Quản lý tải xuống": "Download management",
  "Theo dõi file được tải nhiều, lượt bị chặn và các điểm cần kiểm tra để tránh bot tạo chi phí.": "Track popular files, blocked requests and checks that help prevent bot-driven costs.",
  "Tổng lượt tải": "Total downloads",
  "Mẫu trong kỳ": "Sample in period",
  "Đã chặn": "Blocked",
  "IP / hành vi mẫu": "Sample IP / behavior",
  "File phổ biến": "Popular format",
  "Định dạng mẫu": "Sample format",
  "Cảnh báo": "Alerts",
  "Cần xem xét": "Needs review",
  "DOWNLOAD LOG": "DOWNLOAD LOG",
  "Nhật ký tài nguyên": "Resource log",
  "Lượt tải": "Downloads",
  "Trạng thái": "Status",
  "Ổn định": "Stable",
  "Điểm nối bảo mật": "Security connection point",
  "Khi có backend, khu vực này sẽ nhận event tải xuống, hash file, IP đã băm, user agent và rule chặn. Không lưu dữ liệu cá nhân thô trong dashboard.": "When the backend is connected, this area will receive download events, file hashes, hashed IPs, user agents and blocking rules. Raw personal data will not be stored in the dashboard.",
  "CUSTOMER REQUESTS": "CUSTOMER REQUESTS",
  "Tiếp nhận yêu cầu": "Customer requests",
  "Mỗi yêu cầu từ form Liên hệ sẽ được đưa vào đây để phân loại, xử lý và đóng lại.": "Requests from the Contact form will appear here for triage, handling and closure.",
  "Chưa tiếp nhận": "New",
  "Đang xử lý": "In progress",
  "Hoàn thành": "Completed",
  "Tổng yêu cầu": "Total requests",
  "INBOX": "INBOX",
  "Danh sách yêu cầu": "Request list",
  "Lọc trạng thái": "Filter status",
  "Mã": "ID",
  "Yêu cầu": "Request",
  "Email": "Email",
  "Chưa có yêu cầu trong bộ lọc này.": "No requests match this filter.",
  "REVENUE": "REVENUE",
  "Quản lý thu nhập": "Income management",
  "Tách nguồn quảng cáo và Donate để khi kết nối provider có thể đối chiếu rõ từng khoản.": "Separate ads and Donate so each provider can be reconciled when connected.",
  "AdSense / provider": "AdSense / provider",
  "Chuyển khoản / provider": "Bank transfer / provider",
  "Tổng cộng": "Total",
  "Số liệu minh họa": "Illustrative data",
  "REVENUE TREND": "REVENUE TREND",
  "Dòng tiền theo tháng": "Monthly cash flow",
  "Biểu đồ doanh thu minh họa": "Illustrative revenue chart",
  "BREAKDOWN": "BREAKDOWN",
  "Nguồn thu": "Revenue sources",
  "Provider thật sẽ được nối vào adapter thu nhập, kèm thời điểm đồng bộ và trạng thái đối soát.": "The real provider will connect through an income adapter with sync time and reconciliation status.",
  "Admin DesignForge | Quản trị": "DesignForge Admin | Console",
  "Tổng quan": "Overview",
  "Traffic": "Traffic",
  "Công cụ sử dụng": "Tool usage",
  "Yêu cầu khách hàng": "Customer requests",
  "Thu nhập": "Income",
  "Traffic & phát hiện bot": "Traffic & bot detection",
  "Nhìn rõ nguồn truy cập để biết website đang được dùng thật hay bị crawler tạo tải.": "See where visits come from and separate real usage from crawler load.",
  "Mẫu phân loại": "Sample classification",
  "Cần kiểm tra rule": "Rules to review",
  "Thời gian phiên": "Session duration",
  "Mẫu trung bình": "Sample average",
  "Tỷ lệ quay lại": "Return rate",
  "Mẫu retention": "Sample retention",
  "Thêm định dạng EPS cho converter": "Add EPS format to the converter",
  "Không tải được file PDF lớn": "Unable to download a large PDF",
  "Góp ý giao diện mobile": "Feedback on the mobile interface",
  "Yêu cầu không phù hợp": "Inappropriate request",
  "Hôm nay, 09:42": "Today, 09:42",
  "Hôm qua, 16:08": "Yesterday, 16:08",
  "18/10/2026": "18/10/2026",
  "17/10/2026": "17/10/2026",
  "Một góc nhìn rõ ràng về DesignForge.": "A clear view of DesignForge.",
  "Hiểu nguồn truy cập và các dấu hiệu truy cập tự động.": "Understand traffic sources and signs of automated visits.",
  "Traffic & bot": "Traffic & bots",
  "Sử dụng công cụ": "Tool usage",
  "Biết công cụ nào hữu ích nhất để ưu tiên phát triển.": "Find the most useful tools to guide development.",
  "Tải xuống & bảo mật": "Downloads & security",
  "Theo dõi tài nguyên, dung lượng và giới hạn tải.": "Track resources, transfer volume and download limits.",
  "Lắng nghe, tiếp nhận và theo dõi từng yêu cầu.": "Read, review and follow up on every request.",
  "Theo dõi quảng cáo và những đóng góp cho DesignForge.": "Track advertising and contributions to DesignForge.",
  "Không gian quản trị": "Admin workspace",
  "ĐIỀU HÀNH": "MANAGEMENT",
  "Sẵn sàng cho bước tiếp theo": "Ready for the next step",
  "Xem trạng thái kết nối": "View connections",
  "Nguồn hiển thị": "Display source",
  "Chưa kết nối": "Not connected",
  "Bạn đang xem dữ liệu mẫu. Thay đổi chỉ có hiệu lực trong phiên xem thử, tải lại trang sẽ đặt lại.": "You are viewing sample data. Changes last only for this preview session and reset on reload.",
  "Chưa có nguồn dữ liệu. Kết nối dịch vụ để bắt đầu thu thập thống kê thật.": "No data source connected. Connect services to start collecting real statistics.",
  "BẢN XEM THỬ": "PREVIEW",
  "Toàn bộ hộp thư": "All requests",
  "Trạng thái cập nhật trong phiên mẫu": "Status changes apply to this preview session",
  "Không tải được dữ liệu": "Unable to load data",
  "Thử tải lại dữ liệu quản trị.": "Try loading the admin data again.",
  "Đang chuẩn bị dashboard…": "Preparing dashboard…",
  "Chưa có dữ liệu thống kê": "No statistics yet",
  "Chọn Dữ liệu mẫu để khám phá bố cục và các thao tác quản trị.": "Select Sample data to explore the layout and admin actions.",
  "Bao gồm người, bot và chưa rõ": "Includes likely humans, bots and unknown",
  "Lượt dùng công cụ": "Tool uses",
  "Lượt bắt đầu thao tác": "Operations started",
  "Lượt tải thành công": "Successful downloads",
  "Tài nguyên từ máy chủ": "Resources from the server",
  "Cần phản hồi": "Needs a response",
  "Toàn bộ hộp thư mẫu": "Across the sample inbox",
  "Công việc cần chú ý": "Needs your attention",
  "Hộp thư & tài nguyên": "Inbox & resources",
  "Yêu cầu chưa tiếp nhận": "Requests awaiting review",
  "yêu cầu mẫu đang chờ bạn": "sample requests awaiting review",
  "Rà soát lượt tải bị chặn": "Review blocked downloads",
  "lượt trong kỳ mẫu": "events in the sample period",
  "Các tín hiệu này chỉ minh họa cách vận hành dashboard.": "These signals only illustrate how the dashboard works.",
  "Tổng lượt truy cập": "Total visits",
  "Request trang đã ghi nhận": "Recorded page requests",
  "Có dấu hiệu người": "Likely human",
  "Phân loại ước tính": "Estimated classification",
  "Theo tín hiệu nhận diện": "Based on detection signals",
  "Chưa phân loại": "Unclassified",
  "Không đủ tín hiệu": "Insufficient signals",
  "Nguồn truy cập": "Traffic sources",
  "Phân bổ trong kỳ": "Distribution for the period",
  "Hiểu đúng về bot": "Understanding bots",
  "Phân loại có độ tin cậy": "Classification confidence",
  "Phân loại người/bot là ước tính. Bot tốt như công cụ tìm kiếm cũng cần được nhận diện riêng; không tự động chặn tất cả crawler.": "Human/bot classification is an estimate. Useful bots such as search engines need separate recognition; do not automatically block every crawler.",
  "Nguồn dự kiến: log máy chủ và tín hiệu Cloudflare nếu gói dịch vụ hỗ trợ. Trình duyệt riêng lẻ không xác minh chắc chắn người thật.": "Planned sources: server logs and Cloudflare signals where supported by the service plan. Browser data alone cannot reliably verify human visitors.",
  "Sự kiện bắt đầu": "Start events",
  "Thao tác thành công": "Successful operations",
  "Sự kiện hoàn tất": "Completion events",
  "Công cụ được theo dõi": "Tracked tools",
  "Trong bộ dữ liệu mẫu": "In the sample dataset",
  "Một lượt dùng là một lần bắt đầu thao tác; một lần mở trang không tự tính là sử dụng công cụ.": "A use means starting an operation; opening a page does not automatically count as using a tool.",
  "Không có dữ liệu thật trong bản xem thử": "No live data in this preview",
  "Xếp hạng trong kỳ": "Ranking for the period",
  "Xem tất cả": "View all",
  "Lượt dùng giảm dần": "Most uses first",
  "Bảng xếp hạng công cụ": "Tool ranking",
  "Hoàn tất": "Completed",
  "Không có kết quả phù hợp.": "No matching results.",
  "Lượt bị chặn": "Blocked attempts",
  "Do quy tắc bảo vệ mẫu": "Blocked by sample rules",
  "Dung lượng truyền": "Data transferred",
  "Không phải chi phí hóa đơn": "Does not represent billed costs",
  "Tài nguyên tải xuống": "Resource downloads",
  "Theo dõi từng file": "Track each file",
  "Có lượt bị chặn": "With blocked attempts",
  "Thống kê tài nguyên": "Resource statistics",
  "Bị chặn": "Blocked",
  "Tài nguyên minh họa": "Sample resource",
  "Quy tắc bảo vệ tải xuống": "Download protection rules",
  "Bản nháp · Chưa được áp dụng": "Draft · Not enforced",
  "Đã lưu bản nháp trong phiên mẫu. Chưa áp dụng lên website.": "Draft saved for this preview session. Not applied to the website.",
  "Không lưu được. Kiểm tra giá trị và thử lại.": "Unable to save. Check the values and try again.",
  "Các giới hạn này chỉ là bản nháp. Cần backend thực thi và công tắc ngắt tải để kiểm soát lưu lượng thật.": "These limits are a draft. Server enforcement and a download stop switch are needed to control real traffic.",
  "Lượt tải / phút / IP": "Downloads / minute / IP",
  "Ngưỡng tải toàn site / ngày": "Site download limit / day",
  "Xác minh khi có dấu hiệu bất thường": "Challenge suspicious activity",
  "Dự kiến tích hợp Turnstile hoặc dịch vụ tương đương": "Planned Turnstile or equivalent integration",
  "Tạm dừng toàn bộ tải xuống": "Pause all downloads",
  "Công tắc khẩn cấp trong bản nháp": "Emergency switch in this draft",
  "Thay đổi không ảnh hưởng website công khai.": "Changes do not affect the public website.",
  "Hủy thay đổi": "Discard changes",
  "Đang lưu…": "Saving…",
  "Lưu bản nháp": "Save draft",
  "File xuất cục bộ từ các công cụ được thống kê riêng; bảng này dành cho tài nguyên tải từ máy chủ.": "Local tool exports are tracked separately; this table covers resources downloaded from the server.",
  "Quảng cáo · Ước tính": "Ads · Estimated",
  "Dữ liệu mẫu AdSense": "Sample AdSense data",
  "Donate · Đã đối soát": "Donate · Reconciled",
  "Dữ liệu mẫu chuyển khoản": "Sample bank transfer data",
  "Tổng quy đổi": "Converted total",
  "Chưa thiết lập tỷ giá": "Exchange rate not configured",
  "Đối chiếu nguồn thu": "Revenue reconciliation",
  "Giữ riêng đơn vị tiền tệ": "Currencies kept separate",
  "Nguồn": "Source",
  "Số tiền": "Amount",
  "Loại số liệu": "Data type",
  "Đồng bộ thật": "Live sync",
  "Ước tính · Mẫu": "Estimated · Sample",
  "Đã đối soát · Mẫu": "Reconciled · Sample",
  "Không suy ra doanh thu từ lượt xem. AdSense cung cấp doanh thu riêng; Donate cần xác nhận từ ngân hàng hoặc nguồn thanh toán. Không cộng USD với VND khi chưa có tỷ giá.": "Revenue is not inferred from page views. AdSense provides its own revenue reports; donations need bank or payment confirmation. USD and VND are not added without an exchange rate.",
  "Traffic & sự kiện": "Traffic & events",
  "Kết nối analytics, sự kiện công cụ và tín hiệu bot.": "Connect analytics, tool events and bot signals.",
  "Log tải, giới hạn máy chủ và công tắc ngắt tải.": "Download logs, server limits and an emergency stop switch.",
  "Yêu cầu & email": "Requests & email",
  "Form Liên hệ hiện dùng mailto; cần API lưu yêu cầu.": "Contact currently uses mailto; an API is needed to store requests.",
  "Kết nối báo cáo quảng cáo và đối soát khoản ủng hộ.": "Connect advertising reports and reconcile donations.",
  "Trạng thái kết nối": "Connection status",
  "0/5 đã kết nối": "0/5 connected",
  "Chờ thiết lập": "Setup required",
  "Nhịp truy cập": "Traffic over time",
  "Lượt truy cập trong kỳ": "Visits for the period",
  "Biểu đồ truy cập; số liệu chi tiết ở bảng bên dưới.": "Traffic chart; detailed figures are available in the data table.",
  "Xem số liệu biểu đồ": "View chart data",
  "Mốc thời gian": "Time interval",
  "Ai đang truy cập?": "Who is visiting?",
  "có dấu hiệu người": "likely human",
  "Tín hiệu ước tính, không phải xác minh danh tính. Giữ nhóm chưa rõ để tránh phân loại sai.": "Estimated signals do not verify identity. An unknown category helps avoid incorrect classifications.",
  "Quảng cáo · USD": "Advertising · USD",
  "Donate · VND": "Donate · VND",
  "Xu hướng trong kỳ": "Trend for the period",
  "Mức cao nhất": "Peak value",
  "Nội dung & tiến độ xử lý": "Messages & progress",
  "Tìm yêu cầu": "Search requests",
  "Tìm nội dung, email hoặc mã...": "Search messages, email or ID...",
  "Tất cả đang lưu": "All active requests",
  "Người gửi": "Sender",
  "Nhận lúc · UTC+7": "Received · UTC+7",
  "Thao tác": "Actions",
  "Mở yêu cầu": "Open request",
  "Không có yêu cầu phù hợp": "No matching requests",
  "Hộp thư chưa kết nối": "Inbox not connected",
  "Thử từ khóa hoặc trạng thái khác.": "Try another keyword or status.",
  "Form Liên hệ hiện dùng mailto. Yêu cầu thật sẽ xuất hiện sau khi kết nối API tiếp nhận.": "The Contact form currently uses mailto. Real requests will appear once an intake API is connected.",
  "Xóa bộ lọc": "Clear filters",
  "yêu cầu hiển thị": "requests shown",
  "Xóa đưa vào thùng rác, có thể khôi phục.": "Deleted requests go to the trash and can be restored.",
  "Đã cập nhật yêu cầu mẫu. Chưa gửi email cho người dùng.": "Sample request updated. No email was sent to the user.",
  "Yêu cầu mẫu": "Sample request",
  "Đóng chi tiết yêu cầu": "Close request details",
  "Trạng thái xử lý": "Request status",
  "Ghi chú nội bộ": "Internal note",
  "Ghi lại hướng xử lý hoặc việc cần làm...": "Record next steps or work to be done...",
  "Xem mẫu email phản hồi": "Preview reply email",
  "Yêu cầu của bạn đã được tiếp nhận và hoàn thành. Cảm ơn bạn đã góp ý và sử dụng DesignForge. Chúc bạn một ngày làm việc thuận lợi!": "Your request has been reviewed and completed. Thank you for your feedback and for using DesignForge. Have a productive day!",
  "Mình đã tiếp nhận ý kiến của bạn và sẽ xem xét xử lý. Cảm ơn bạn đã góp ý để DesignForge ngày càng hữu ích hơn!": "I have received your feedback and will review it. Thank you for helping make DesignForge more useful!",
  "Chỉ là bản xem trước. Chưa kết nối dịch vụ gửi email.": "Preview only. No email delivery service is connected.",
  "Lịch sử trạng thái": "Status history",
  "Khôi phục yêu cầu": "Restore request",
  "Chuyển vào thùng rác": "Move to trash",
  "Lưu thay đổi": "Save changes",
  "Tiếp nhận xử lý": "In progress",
  "Đã xóa": "Deleted",
  "Ngày": "Day",
  "Tháng": "Month",
  "Quý": "Quarter",
  "Năm": "Year",
  "Truy cập trực tiếp": "Direct traffic",
  "Nguồn khác": "Other sources",
  "Công cụ hay dùng mỗi ngày": "Your everyday tools",
  "Full Front-end, file được xử lý ngay trên trình duyệt, không gửi lên server hay thu thập nội dung file của bạn. Không giới hạn lượt dùng, xài tới khi web bị sập thì thôi. Nên bạn cứ yên tâm và quay lại mỗi ngày nhé.": "Fully front-end: your files are processed right in your browser, without uploading them to a server or collecting their contents. No usage limits—keep using the tools until the site gives out! Feel at ease and come back every day.",
  "Giới thiệu": "About",
  "Chính sách riêng tư": "Privacy policy",
  "Thông tin website": "Website information",
  "Giới thiệu | DesignForge": "About | DesignForge",
  "Chính sách riêng tư | DesignForge": "Privacy policy | DesignForge",
  "Giao diện mẫu. Chưa kết nối các nguồn dữ liệu thật.": "Preview interface. Live data sources are not connected.",
  "Phân quyền API quản trị": "Admin API authorization",
  "Thiết lập quyền truy cập API trước khi kết nối dữ liệu thật.": "Configure API access permissions before connecting real data.",
  "Không tải được dữ liệu quản trị.": "Unable to load admin data.",
  "Dữ liệu máy chủ. Kiểm tra nguồn và thời điểm thu thập bên dưới.": "Server data. See collection sources and start time below.",
  "Tải lại dữ liệu": "Refresh data",
  "Thống kê thật kể từ khi kết nối. Không khôi phục số liệu trước thời điểm thu thập.": "Live statistics since collection began. Earlier activity cannot be recovered.",
  "DỮ LIỆU THẬT": "LIVE DATA",
  "Trạng thái lưu trên máy chủ": "Status saved on the server",
  "Chưa kết nối kho tải xuống": "Download storage is not connected",
  "lượt trong kỳ": "in this period",
  "Ghi nhận request tài liệu HTML tới máy chủ; điều hướng trong ứng dụng không tự tính thêm. Nhận diện bot dựa trên tín hiệu Cloudflare và user agent, không xác minh chắc chắn người thật.": "Counts HTML document requests to the server; in-app navigation does not add a request. Bot classification uses Cloudflare signals and user agents, and cannot verify a person with certainty.",
  "Đã ghi nhận sự kiện": "Recorded events",
  "Tải tài nguyên từ máy chủ": "Server resource downloads",
  "Chưa có kho tài nguyên tải xuống được quản lý. Không áp dụng giới hạn cho liên kết bên ngoài hoặc file xử lý cục bộ.": "No managed download storage is connected. Limits do not apply to external links or locally processed files.",
  "File xuất cục bộ": "Local exports",
  "Không phải băng thông máy chủ": "Not server bandwidth",
  "Chưa ghi nhận file xuất trong kỳ.": "No exports recorded in this period.",
  "Chưa kết nối báo cáo doanh thu": "Revenue reporting is not connected",
  "Chưa có nguồn đối soát thanh toán": "No payment reconciliation source",
  "Không suy ra doanh thu từ lượt xem. Không có số liệu không đồng nghĩa doanh thu bằng không.": "Revenue is not inferred from views. Unavailable data does not mean zero revenue.",
  "Tải tài nguyên": "Resource downloads",
  "Đã kết nối": "Connected",
  "Lỗi kết nối": "Connection error",
  "Bắt đầu thu thập": "Collection began",
  "Đang hiển thị yêu cầu mới nhất": "Showing the latest requests",
  "Thống kê trạng thái và bộ lọc chỉ áp dụng cho danh sách này.": "Status counts and filters apply only to this list.",
  "Đã cập nhật yêu cầu. Chưa gửi email tự động cho người dùng.": "Request updated. No automatic email has been sent to the user.",
  "Yêu cầu đã được cập nhật ở phiên khác. Hãy đóng chi tiết và tải lại dữ liệu.": "This request was updated in another session. Close the details and refresh the data.",
  "Không kết nối được API. Phiên Access có thể đã hết hạn; hãy tải lại trang để đăng nhập hoặc kiểm tra kết nối.": "Unable to connect to the API. Your Access session may have expired; reload the page to sign in or check your connection.",
  "Phiên đăng nhập đã hết hạn. Hãy tải lại trang.": "Your session has expired. Reload the page to sign in.",
  "Chưa có dịch vụ tải xuống để áp dụng quy tắc.": "No download service is connected to enforce these rules.",
  "Vui lòng mô tả ít nhất 5 ký tự.": "Please enter a description of at least 5 characters.",
  "Bạn đã gửi nhiều yêu cầu. Vui lòng thử lại sau hoặc liên hệ qua email.": "You have sent too many requests. Try again later or contact us by email.",
  "Chưa xác nhận được yêu cầu. Thử lại sẽ không tạo bản trùng; bạn cũng có thể liên hệ qua email.": "Your request could not be confirmed. Retrying will not create a duplicate; you can also contact us by email.",
  "Đã nhận yêu cầu của bạn.": "Your request has been received.",
  "Yêu cầu đã được lưu vào hộp thư DesignForge. Mình sẽ xem và phản hồi qua email bạn cung cấp. Website chưa gửi email xác nhận tự động.": "Your request has been saved to the DesignForge inbox. I will review it and reply to the email you provided. The website has not sent an automatic confirmation email.",
  "Mã yêu cầu": "Request ID",
  "Khi gửi, email và nội dung được lưu riêng tư để chủ website xử lý yêu cầu. Không gửi thông tin nhạy cảm.": "When submitted, your email and message are stored privately so the website owner can handle your request. Do not include sensitive information.",
  "Đang gửi…": "Sending…",
  "D1 · thời gian thực từ ngày bật thu thập; không có dữ liệu hồi tố.": "D1 · live data since collection began; no historical backfill.",
  "Chưa kết nối nhà cung cấp. Không suy ra số liệu từ lượt truy cập.": "Provider not connected. Figures are not inferred from traffic.",
  "Chưa cấu hình khóa thu thập.": "The collection key has not been configured.",
  "Sự kiện trình duyệt có giới hạn tần suất; không phải số người dùng duy nhất.": "Browser events are rate limited; these are not unique user counts.",
  "yêu cầu đang chờ bạn": "requests awaiting review",
  "Kho tải xuống chưa kết nối": "Download storage is not connected",
  "Chưa có số liệu lượt tải hoặc chặn tải từ máy chủ.": "Server download and blocked download statistics are unavailable.",
  "Xem trạng thái từng nguồn để hiểu phạm vi dữ liệu đang ghi nhận.": "Check each source status to understand which activity is recorded.",
  "Trực tiếp / chưa rõ": "Direct / unknown",
  "Nội bộ": "Internal",
  "Nguồn ngoài khác": "Other external",
  "Không có thông tin dung lượng": "File size unavailable",
  "Không tải được hộp thư. Kiểm tra trạng thái kết nối và thử tải lại dữ liệu.": "Unable to load the inbox. Check the connection status and refresh the data.",
  "Trong danh sách yêu cầu mới nhất": "In the latest requests list",
  "Không tìm thấy mục đã lưu": "No saved items match your search",
  "Thử xóa bớt từ khóa để xem lại các mục đã lưu.": "Try a shorter search to see your saved items.",
  "Bản nháp": "Draft",
  "Công khai": "Published",
  "Không lưu được tài nguyên. Hãy thử lại.": "Unable to save the resource. Please try again.",
  "Quản lý tài nguyên": "Manage resources",
  "Tài nguyên đang lưu trên trình duyệt này. Bản local không đăng lên website công khai.": "Resources are stored in this browser. Local changes are not published to the live website.",
  "Tài nguyên công khai sẽ xuất hiện ở website. File tải trực tiếp từ dịch vụ lưu trữ bạn chọn.": "Published resources appear on the website. Files download directly from your chosen storage service.",
  "Tải lại danh sách": "Refresh list",
  "Thêm tài nguyên": "Add resource",
  "Không tải được tài nguyên": "Unable to load resources",
  "Đang tải tài nguyên…": "Loading resources…",
  "Tìm tiêu đề hoặc ghi chú...": "Search titles or notes...",
  "Chưa có ghi chú": "No notes yet",
  "Khôi phục": "Restore",
  "Chỉnh sửa": "Edit",
  "Đã ẩn tài nguyên khỏi website.": "Resource hidden from the website.",
  "Ẩn": "Hide",
  "Không có tài nguyên phù hợp": "No matching resources",
  "Đăng tài nguyên đầu tiên": "Publish your first resource",
  "Thêm thumbnail, nội dung và link tải để chia sẻ với mọi người.": "Add a thumbnail, description and download link to share a resource.",
  "tài nguyên hiển thị": "resources shown",
  "Đang hiển thị tài nguyên mới nhất": "Showing the latest resources",
  "Liên kết bên ngoài không xác nhận được số lần tải hoàn tất. Quyền truy cập file do Dropbox hoặc dịch vụ lưu trữ quyết định.": "External links do not confirm completed downloads. File access is controlled by Dropbox or your storage service.",
  "Đã lưu và công khai tài nguyên.": "Resource saved and published.",
  "Đã lưu bản nháp tài nguyên.": "Resource draft saved.",
  "Đã chuyển tài nguyên vào thùng rác.": "Resource moved to trash.",
  "Không tải được ảnh": "Image unavailable",
  "Đóng trình sửa tài nguyên": "Close resource editor",
  "Khôi phục tài nguyên": "Restore resource",
  "Chỉnh sửa tài nguyên": "Edit resource",
  "Tiêu đề tài nguyên": "Resource title",
  "Ví dụ: Bộ mockup bao bì tối giản": "Example: Minimal packaging mockup set",
  "Ghi chú": "Notes",
  "Mô tả ngắn, định dạng file hoặc lưu ý sử dụng...": "Short description, file format or usage notes...",
  "Danh mục": "Category",
  "Link tải xuống": "Download link",
  "Dán link chia sẻ HTTPS. Link Dropbox được tự chuyển sang chế độ tải trực tiếp; hãy cho phép mọi người có link truy cập file.": "Paste an HTTPS share link. Dropbox links are converted to direct downloads; enable access for anyone with the link.",
  "Lưu để hiển thị thẻ và nút tải ở trang Tài nguyên.": "Save to display the card and download button on Resources.",
  "Bản nháp chỉ xuất hiện trong admin. Chọn Công khai khi sẵn sàng.": "Drafts are only visible in admin. Choose Published when ready.",
  "Ảnh thumbnail": "Thumbnail",
  "Ảnh xem trước tài nguyên": "Resource preview",
  "Đang tải ảnh…": "Uploading image…",
  "Chọn ảnh từ máy": "Choose an image",
  "Chọn ảnh thumbnail": "Choose thumbnail image",
  "JPG, PNG hoặc WebP. Ảnh được tối ưu trước khi tải lên.": "JPG, PNG or WebP. Images are optimized before upload.",
  "Hoặc dán URL ảnh": "Or paste an image URL",
  "Đã chọn ảnh từ máy": "An image has been selected",
  "Hủy": "Cancel",
  "Khôi phục và lưu": "Restore and save",
  "Lưu tài nguyên": "Save resource",
  "Xóa tài nguyên": "Delete resource",
  "Chuyển tài nguyên này vào thùng rác?": "Move this resource to trash?",
  "Thẻ sẽ được ẩn khỏi website. Bạn có thể khôi phục từ mục Đã xóa; file gốc trên dịch vụ lưu trữ không bị xóa.": "The card will be hidden from the website. Restore it from Deleted; the original file in your storage service will remain available.",
  "Đăng tài nguyên, quản lý thumbnail và liên kết tải xuống.": "Publish resources and manage thumbnails and download links.",
  "Quản lý nội dung tài nguyên": "Resource content management",
  "Không kết nối được API tài nguyên. Hãy kiểm tra kết nối hoặc tải lại trang để đăng nhập Access.": "Unable to connect to the resource API. Check your connection or reload to sign in with Access.",
  "Tài nguyên đã thay đổi ở phiên khác. Hãy tải lại danh sách trước khi lưu.": "This resource changed in another session. Refresh the list before saving.",
  "Thumbnail quá lớn. Hãy chọn ảnh nhỏ hơn.": "Thumbnail is too large. Choose a smaller image.",
  "Đã đạt giới hạn lưu trữ tài nguyên. Hãy thử lại sau.": "Resource storage has reached its limit. Please try again later.",
  "Không lưu hoặc tải được tài nguyên. Kiểm tra thông tin rồi thử lại.": "Unable to save or load resources. Check the details and try again.",
  "API tài nguyên trả về dữ liệu không hợp lệ.": "The resource API returned invalid data.",
  "Không đọc được ảnh thumbnail.": "Unable to read the thumbnail image.",
  "Chỉ chấp nhận ảnh JPG, PNG hoặc WebP.": "Only JPG, PNG and WebP images are supported.",
  "Ảnh gốc tối đa 20 MB.": "The original image must be 20 MB or smaller.",
  "Kích thước ảnh quá lớn. Hãy giảm kích thước trước khi tải lên.": "The image dimensions are too large. Resize it before uploading.",
  "Không chuẩn bị được thumbnail.": "Unable to prepare the thumbnail.",
  "Không nén được thumbnail xuống 256 KB. Hãy chọn ảnh nhỏ hơn.": "Unable to compress the thumbnail to 256 KB. Choose a smaller image.",
  "Bản local: tài nguyên thử được lưu trên trình duyệt này, chưa đăng lên website thật.": "Local preview: resources are stored in this browser and are not published to the live website.",
  "Không tải được tài nguyên đã đăng": "Unable to load published resources",
  "Hãy thử lại để tải danh sách tài nguyên.": "Please try again to load the resource list.",
  "Đang cập nhật tài nguyên...": "Updating resources...",
  "Đang hiển thị các tài nguyên mới nhất trong giới hạn danh sách.": "Showing the latest resources within the list limit.",
  "Không tải được ảnh xem trước": "Preview unavailable",
  "Bỏ lưu": "Unsave",
  "Lưu": "Save",
  "Tải xuống": "Download",
  "Không kết nối được kho tài nguyên. Hãy thử lại.": "Unable to connect to the resource library. Please try again.",
  "Không tải được kho tài nguyên. Hãy thử lại.": "Unable to load the resource library. Please try again.",
  "Không mở được bộ nhớ tài nguyên trong trình duyệt.": "Unable to open resource storage in this browser.",
  "Hãy đóng các tab DesignForge cũ rồi thử lại.": "Close older DesignForge tabs and try again.",
  "Không đọc được tài nguyên đã lưu trên trình duyệt.": "Unable to read resources stored in this browser.",
  "Thumbnail quá lớn. Hãy chọn lại ảnh.": "Thumbnail is too large. Choose another image.",
  "Không tìm thấy tài nguyên.": "Resource not found.",
  "Không lưu được tài nguyên.": "Unable to save the resource.",
  "Bộ nhớ local đã đạt giới hạn 1.000 tài nguyên.": "Local storage has reached the 1,000-resource limit.",
  "Không lưu được tài nguyên trên trình duyệt.": "Unable to save the resource in this browser.",
  "Hãy nhập tiêu đề, tối đa 140 ký tự.": "Enter a title of up to 140 characters.",
  "Ghi chú tối đa 2.000 ký tự.": "Notes must be 2,000 characters or fewer.",
  "Hãy chọn danh mục và trạng thái hợp lệ.": "Choose a valid category and status.",
  "Link ảnh và link tải phải là địa chỉ HTTPS công khai, tối đa 2.048 ký tự và không kèm mật khẩu.": "Image and download links must be public HTTPS URLs of up to 2,048 characters, without passwords.",
  "Kho tài nguyên hoặc thumbnail đã đầy. Liên hệ quản trị để dọn dữ liệu trước khi thêm mới.": "Resource or thumbnail storage is full. Ask the administrator to remove old data before adding more.",
  "Tất cả tài nguyên đang lưu": "All active resources",
  "Xóa đưa tài nguyên vào thùng rác, có thể khôi phục.": "Deleted resources go to Trash and can be restored.",
  "Cách ủng hộ": "Ways to support",
  "Chuyển khoản Việt Nam": "Bank transfer in Vietnam",
  "Quét VietQR hoặc chuyển khoản": "Scan VietQR or make a transfer",
  "Ủng hộ qua PayPal": "Support via PayPal",
  "Quốc tế · Tự chọn số tiền": "International · Choose your amount",
  "Mở mã VietQR kích thước đầy đủ": "Open the full-size VietQR code",
  "Mã VietQR ủng hộ DesignForge qua MB Bank": "VietQR code to support DesignForge via MB Bank",
  "Tải mã QR": "Download QR code",
  "Sao chép số tài khoản": "Copy account number",
  "Sao chép nội dung": "Copy transfer note",
  "Không sao chép được. Bạn có thể chọn và sao chép thông tin bên trên.": "Unable to copy. You can select and copy the details above.",
  "Đã sao chép số tài khoản.": "Account number copied.",
  "Đã sao chép nội dung chuyển khoản.": "Transfer note copied.",
  "Tôi sẽ cập nhật prompt thường xuyên, hoặc nếu bạn có nhu cầu cần thêm prompt về bất kỳ lĩnh vực nào, hãy liên hệ tôi, sự góp sức của bạn sẽ giúp website trở nên lớn mạnh.": "I'll update the prompts regularly. If you'd like prompts for any field, please get in touch. Your contribution will help this website grow.",
  "Khi tạo ảnh, đính kèm ảnh sản phẩm cùng prompt. Không cần nhập lại thương hiệu hay tên sản phẩm.": "Attach your product photo with the prompt when generating an image. No need to re-enter its brand or product name.",
  "Poster sản phẩm cao cấp với pedestal, nền tối và splash.": "A premium product poster with a pedestal, dark background and splashes.",
  "11 trường": "11 fields",
  "Tự lấy từ ảnh sản phẩm": "Use the product photo",
  "Tự phối theo sản phẩm và trái cây": "Match the product and fruit",
  "Tự phối theo sản phẩm và trái cây trong đá": "Match the product and frozen fruit",
  "Tự lấy từ trái cây chính": "Use the main fruit",
  "Tự phối theo trái cây chính": "Match the main fruit",
  "Tự chọn nền đậm hài hòa": "Choose a matching dark background",
  "Mặc định dùng trái cây chính": "Use the main fruit by default",
  "Tự chọn hương vị hoặc đạo cụ theo ảnh sản phẩm": "Choose a theme or props from the product photo",
  "Tự chọn nguyên liệu phù hợp": "Choose matching ingredients",
  "Tự chọn chi tiết phụ phù hợp": "Choose matching details",
  "Tự chọn trái cây cho bối cảnh": "Choose fruit for the scene",
  "Tự chọn trái cây chính": "Choose the main fruit",
  "4 trường": "4 fields",
  "Poster nước trái cây mùa hè với lưới bóng chuyền chéo và chiều sâu bãi biển.": "A summer juice poster with a diagonal volleyball net and layered beach perspective.",
  "Prompt quảng cáo nước trái cây mùa hè trên sân bóng chuyền bãi biển": "Summer juice advertising prompt on a beach volleyball court",
  "Poster quảng cáo nước trái cây mùa hè trên bãi biển với lưới bóng chuyền và hai sản phẩm": "Summer juice advertising poster on a beach with a volleyball net and two product instances",
  "Màu bầu trời": "Sky color",
  "Để trống để dùng bầu trời xanh mùa hè": "Leave blank for a blue summer sky",
  "Tự chọn trái cây hoặc lấy theo bao bì": "Choose fruit or use the packaging",
  "Tự tạo slogan tiếng Anh theo sản phẩm": "Generate an English slogan for the product",
  "Tự tạo dòng mô tả tiếng Anh theo sản phẩm": "Generate an English description for the product",
  "Tùy chỉnh nội dung chữ": "Customize poster text",
  "Poster nước trái cây với ba sản phẩm, kiến trúc hồng pastel và nắng nhiệt đới.": "A juice poster with three product instances, pastel-pink architecture and tropical sunlight.",
  "Prompt nước trái cây nhiệt đới với ba lon trên nền hồng pastel": "Tropical juice prompt with three cans in a pastel-pink setting",
  "Poster nước trái cây · Tropical pastel campaign": "Juice poster · Tropical pastel campaign",
  "Poster nước trái cây ba lon trên bục và sàn hồng pastel với trái cây và bóng lá cọ": "Juice poster with three cans on pink pedestals and a glossy pastel floor, fruit and palm-leaf shadows",
  "Poster nước dừa trên trái cây tươi, splash nước lạnh và bầu trời nhiệt đới.": "A coconut-water poster with fresh fruit, cold-water splashes and a tropical sky.",
  "Tự nhận diện từ ảnh sản phẩm": "Identify from the product photo",
  "Prompt nước dừa nhiệt đới với trái cây tươi và splash nước": "Tropical coconut-water prompt with fresh fruit and water splashes",
  "Poster nước dừa · Tropical daylight campaign": "Coconut-water poster · Tropical daylight campaign",
  "Poster nước dừa với lon sản phẩm giữa trái dừa xanh, splash nước và lá cọ dưới bầu trời xanh": "Coconut-water poster with a product can among green coconuts, water splashes and palm leaves beneath a blue sky",
  "Áp dụng cắt": "Apply crop",
  "Xóa đối tượng": "Delete object",
  "Theo dõi lượt mở link tài nguyên và file xuất từ công cụ.": "Track resource link opens and files exported by tools.",
  "Lượt mở link tải": "Download link opens",
  "Không xác nhận tải hoàn tất": "Completed downloads are not confirmed",
  "Lượt mở link tải theo tài nguyên": "Download link opens by resource",
  "Xem lượt mở link; không xác nhận tải hoàn tất.": "View link opens; completed downloads are not confirmed.",
  "Qua liên kết trên DesignForge": "Through links on DesignForge",
  "Tài nguyên có lượt mở": "Resources with link opens",
  "Trong khoảng thời gian đã chọn": "In the selected period",
  "Lượt tải hoàn tất": "Completed downloads",
  "Dịch vụ ngoài chưa cung cấp xác nhận": "The external provider has not supplied confirmation",
  "Dữ liệu máy chủ · D1": "Server data · D1",
  "Ghi nhận khi mở link tải qua DesignForge. File do dịch vụ bên ngoài cung cấp; lượt mở không xác nhận tải thành công hoặc số người duy nhất.": "Recorded when a download link is opened through DesignForge. Files are served by an external provider; opens do not confirm successful downloads or unique people.",
  "Chưa có tài nguyên được công khai hoặc lượt mở trong kỳ.": "No published resources or link opens in this period yet.",
  "Lượt mở đầu tiên được ghi nhận": "First recorded link open",
  "Bắt đầu ghi nhận từ lượt mở đầu tiên; không có dữ liệu hồi tố.": "Collection starts with the first link open; past activity is not available.",
  "Loại lượt xem trước, prefetch và bot đã nhận diện. Giới hạn ghi nhận: 120 lượt/IP/ngày và 2.000 lượt/toàn site/ngày (UTC); vượt ngưỡng vẫn mở link nhưng không tăng số liệu. Không kiểm soát được lượt tải trực tiếp từ Dropbox.": "Previews, prefetches and identified bots are excluded. Recording caps: 120 opens per IP per day and 2,000 sitewide per day (UTC); links still open above these caps without increasing the count. Direct Dropbox downloads cannot be tracked.",
  "D1 · lượt mở link tải qua DesignForge, có giới hạn tần suất và loại bot đã nhận diện; không xác nhận tải xong hoặc người duy nhất. Không có dữ liệu hồi tố.": "D1 · download link opens through DesignForge, with recording caps and identified bots excluded; completed downloads and unique people are not confirmed. No past activity is available.",
  "Mất kết nối với dịch vụ. Vui lòng thử lại.": "Connection to the service was lost. Please try again.",
  "Chỉ nhận ảnh PNG, JPG hoặc WebP.": "Only PNG, JPG or WebP images are supported.",
  "Ảnh phải nhỏ hơn hoặc bằng 10 MB.": "The image must be 10 MB or smaller.",
  "Chỉ hỗ trợ phóng lớn 2× hoặc 4×.": "Only 2× and 4× upscaling are supported.",
  "Đã hết lượt xử lý. Vui lòng thử lại sau.": "The processing limit has been reached. Please try again later.",
  "Dịch vụ upscale chưa được cấu hình.": "The upscaling service has not been configured yet.",
  "Dịch vụ upscale tạm thời không sẵn sàng.": "The upscaling service is temporarily unavailable.",
  "Phiên xử lý đã hết hạn. Hãy thử lại.": "The processing session has expired. Please try again.",
  "Không thể xử lý ảnh. Vui lòng thử lại.": "Unable to process the image. Please try again.",
  "Phản hồi từ dịch vụ không hợp lệ.": "The service returned an invalid response.",
  "Ảnh kết quả không hợp lệ.": "The output image is invalid.",
  "Kích thước ảnh kết quả không đúng.": "The output image dimensions are incorrect.",
  "Mỗi lần chỉ chọn một ảnh.": "Choose one image at a time.",
  "Đang xử lý, vui lòng đợi": "Processing, please wait",
  "Đang chờ GPU…": "Waiting for GPU…",
  "Đang upscale trên máy chủ…": "Upscaling on the server…",
  "Đang kiểm tra ảnh kết quả…": "Verifying output image…",
  "Yêu cầu đã được hủy.": "The request was cancelled.",
  "Đang gửi yêu cầu hủy…": "Requesting cancellation…",
  "Đã gửi yêu cầu hủy. Máy chủ có thể cần thêm thời gian để dừng.": "Cancellation requested. The server may need more time to stop.",
  "Đã dừng chờ. Chưa xác nhận máy chủ đã hủy xử lý.": "Stopped waiting. Server-side cancellation could not be confirmed.",
  "Đã dừng tải lên. Nếu máy chủ đã nhận ảnh, xử lý có thể vẫn tiếp tục.": "Upload stopped. Processing may continue if the server already received the image.",
  "Đang kiểm tra dịch vụ…": "Checking service…",
  "Chọn ảnh để upscale": "Choose an image to upscale",
  "Đổi ảnh để upscale": "Change the image to upscale",
  "Ảnh đã chọn để upscale": "Selected image for upscaling",
  "Xóa ảnh đã chọn": "Remove selected image",
  "Đang đọc ảnh…": "Reading image…",
  "Kéo ảnh vào để upscale": "Drop an image to upscale",
  "Model upscale": "Upscaling model",
  "Phóng lớn": "Scale",
  "Tỷ lệ upscale": "Upscaling scale",
  "Token khả dụng": "Available tokens",
  "Giải thích token": "About tokens",
  "Ngân sách chung, mọi người quay lại web thường xuyên để tôi có thêm 1 chút chi phí gia hạn cho mọi người dùng nhé, cảm ơn.": "This is a shared budget. Please visit the website regularly to help me cover the cost of renewing access for everyone. Thank you!",
  "Ngân sách khả dụng chưa đủ cho lượt mới và mức dự phòng 100 token.": "The available budget cannot cover a new request while preserving the 100-token reserve.",
  "Chưa xác nhận được ngân sách. Model tạm khóa để bảo vệ chi phí.": "The budget could not be verified. This model is temporarily locked to protect spending.",
  "Hủy xử lý": "Cancel processing",
  "Upscale & tải PNG": "Upscale & download PNG",
  "Kiểm tra lại dịch vụ": "Check service again",
  "Tải lại PNG": "Download PNG again",
  "Upscale trên máy chủ": "Server-side upscaling",
  "AI xử lý trên máy chủ": "Server-side AI processing",
  "Ảnh được gửi khi bạn bấm Upscale.": "Images upload when you press Upscale.",
  "Công cụ cho thiết kế": "Tools for design",
  "Img Upscaler dùng dịch vụ đám mây.": "Img Upscaler uses a cloud service.",
  "Các công cụ trong khay này xử lý file ngay trên trình duyệt, không gửi nội dung file lên server và không giới hạn lượt dùng. Riêng Img Upscaler trong nhóm AI dùng dịch vụ đám mây và có hạn mức riêng.": "The tools in this shelf process files in your browser, without uploading file contents or imposing usage-count limits. Img Upscaler in the AI collection uses a cloud service with separate limits.",
  "Ảnh không hợp lệ hoặc vượt giới hạn xử lý. Hãy chọn ảnh khác.": "The image is invalid or exceeds processing limits. Choose another image.",
  "Chưa xác nhận máy chủ đã nhận ảnh. Xử lý có thể vẫn tiếp tục; tránh gửi lại ngay.": "The server could not confirm receipt. Processing may continue; avoid submitting again immediately.",
  "Yêu cầu đang được khởi tạo. Vui lòng chờ.": "The request is being started. Please wait.",
  "Đang kiểm tra quá nhanh. Vui lòng chờ rồi thử lại.": "Checking too frequently. Please wait before trying again.",
  "Đã hết lượt lấy kết quả của phiên này.": "The result retrieval limit for this session has been reached.",
  "Ảnh kết quả chưa sẵn sàng.": "The output image is not ready yet.",
  "Yêu cầu bị trùng. Vui lòng bắt đầu phiên mới.": "The request conflicts with an existing request. Start a new session.",
  "Công cụ này cần mở trên DesignForge.": "Open this tool on DesignForge to use it.",
  "Mở trên DesignForge": "Open on DesignForge",
  "Phóng lớn ảnh AI miễn phí 2×/4×, cạnh ảnh có thể đạt 8K; tải PNG khi ngân sách chung còn khả dụng.": "Upscale images free with AI at 2×/4×, with an edge up to 8K; download PNG while the shared budget is available.",
  "Ảnh nguồn tối đa 67.108.864 pixel.": "The source image can contain up to 67,108,864 pixels.",
  "Mỗi cạnh ảnh nguồn tối đa 32768 pixel.": "Each source image edge can be up to 32768 pixels.",
  "Ảnh đầu ra vượt giới hạn xử lý hiện tại.": "The output exceeds the current processing limit.",
  "Tối đa 10 MB · 67,1 megapixel": "Up to 10 MB · 67.1 megapixels",
  "Đầu ra tối đa 8192 × 8192 px": "Output up to 8192 × 8192 px",
  "Đã tự điều chỉnh kích thước để đầu ra không vượt 8192 px mỗi cạnh.": "Dimensions were adjusted automatically to keep each output edge within 8192 px.",
  "Ảnh gốc": "Original image",
  "Đường vector": "Vector path",
  "Nhóm PDF": "PDF group",
  "Chuyển sắc": "Gradient",
  "Đối tượng PDF": "PDF object",
  "Đã hủy. Nội dung trước thao tác được giữ nguyên.": "Canceled. The content before this operation has been preserved.",
  "Trang ảnh không có đối tượng PDF gốc. Dùng Thay chữ nâng cao để xử lý ảnh scan.": "This image-only page has no original PDF objects. Use Advanced text replacement for scanned pages.",
  "Chọn đối tượng để chỉnh. Bấm đúp vào chữ để nhập trực tiếp.": "Select an object to edit. Double-click text to edit it directly.",
  "Đang đọc nội dung PDF…": "Reading PDF content…",
  "Trang này không có chữ gốc. Bạn vẫn có thể chọn ảnh hoặc vector.": "This page has no original text. You can still select images or vectors.",
  "Nội dung PDF gốc": "Original PDF content",
  "đối tượng": "objects",
  "Đổi kích thước": "Resize",
  "Đang cập nhật nội dung gốc…": "Updating original content…",
  "Đã cập nhật nội dung gốc.": "Original content updated.",
  "Chọn đối tượng": "Select object",
  "Ẩn đối tượng": "Hide object",
  "Hiện đối tượng": "Show object",
  "Không có đối tượng phù hợp.": "No matching objects.",
  "Nội dung gốc sẽ xuất hiện tại đây sau khi đọc trang.": "Original content will appear here after the page is analyzed.",
  "Chọn chữ, ảnh hoặc vector trên trang để xem thuộc tính.": "Select text, an image or a vector on the page to view its properties.",
  "Xóa nội dung gốc": "Delete original content",
  "Một số thuộc tính của đối tượng này chưa hỗ trợ chỉnh sửa.": "Some properties of this object cannot be edited yet.",
  "Nội dung chữ": "Text content",
  "Ưu tiên font gốc": "Prefer original font",
  "Chỉ dùng font gốc": "Use original font only",
  "Noto Sans · Tiếng Việt": "Noto Sans · Vietnamese",
  "Nạp font TTF/OTF…": "Load TTF/OTF font…",
  "Cỡ chữ (pt)": "Font size (pt)",
  "Bố trí đoạn chữ": "Paragraph layout",
  "Tự xuống dòng theo khung": "Wrap text to frame",
  "Rộng khung (pt)": "Frame width (pt)",
  "Giãn dòng": "Line spacing",
  "Căn đoạn chữ": "Paragraph alignment",
  "Các dòng mới giữ vị trí khối chữ; nội dung bên dưới không tự dịch chuyển.": "New lines stay within the text block; content below does not move automatically.",
  "Áp dụng chữ": "Apply text",
  "Bấm đúp trên trang để nhập trực tiếp. Ctrl/⌘ + Enter để áp dụng.": "Double-click on the page to edit directly. Press Ctrl/⌘ + Enter to apply.",
  "Thay ảnh gốc…": "Replace original image…",
  "Màu tô": "Fill color",
  "Màu viền": "Stroke color",
  "Độ dày viền (pt)": "Stroke width (pt)",
  "Rộng (pt)": "Width (pt)",
  "Áp dụng vị trí & kích thước": "Apply position & size",
  "Kích thước phải lớn hơn 0.": "Dimensions must be greater than 0.",
  "Xoay trái 90°": "Rotate left 90°",
  "Xoay phải 90°": "Rotate right 90°",
  "Lùi sau": "Send backward",
  "Đưa trước": "Bring forward",
  "Không tải được font tiếng Việt.": "Could not load the Vietnamese font.",
  "Cỡ chữ phải từ 1 đến 1000 pt.": "Font size must be between 1 and 1000 pt.",
  "Rộng khung hoặc giãn dòng không hợp lệ.": "Invalid frame width or line spacing.",
  "Đã dùng Noto Sans vì font gốc thiếu ký tự mới.": "Noto Sans was used because the original font lacks the new characters.",
  "Đã dùng Noto Sans vì font gốc có độ rộng ký tự không hợp lệ.": "Noto Sans was used because the original font has invalid character widths.",
  "Font gốc không có độ rộng hợp lệ cho ký tự mới. Hãy chọn font khác.": "The original font has no valid width for the new characters. Choose another font.",
  "Font quá lớn. Chọn file dưới 20 MB.": "The font is too large. Choose a file under 20 MB.",
  "Ảnh vượt giới hạn 67 megapixel.": "The image exceeds the 67-megapixel limit.",
  "Sửa chữ gốc": "Edit original text",
  "Áp dụng": "Apply",
  "Vui lòng chờ thao tác chỉnh sửa hoàn tất.": "Please wait for the edit to finish.",
  "Chưa áp dụng được chữ đang sửa.": "The text being edited could not be applied.",
  "Hủy chỉnh sửa": "Discard edits",
  "Đã hủy chỉnh sửa chưa áp dụng. Nội dung gốc được giữ nguyên.": "Unapplied edits were discarded. The original content is unchanged.",
  "Không giữ được nhóm hiển thị của chữ gốc.": "Could not preserve the original text's PDF layer.",
  "Không đọc được nhóm hiển thị của chữ gốc.": "Could not read the original text's PDF layer.",
  "Không thể xác định chính xác nhóm hiển thị của chữ gốc.": "Could not identify the original text's exact PDF layer.",
  "Nhóm hiển thị của chữ gốc chưa hỗ trợ dựng lại.": "Rebuilding this text's PDF layer is not supported yet.",
  "Nội dung gốc": "Original content",
  "Tìm chữ hoặc đối tượng…": "Search text or objects…",
  "Tìm nội dung gốc": "Search original content",
  "Loại nội dung": "Content type",
  "Giấy phép thư viện": "Library licenses",
  "Chỉnh nội dung gốc": "Edit original content",
  "Hoàn tác": "Undo",
  "Làm lại": "Redo",
  "Hiện khung": "Show outlines",
  "Hủy thao tác": "Cancel operation",
  "Đối tượng có phép biến đổi không thể chỉnh sửa.": "This object has a transform that cannot be edited.",
  "Màu đối tượng không hợp lệ.": "Invalid object color.",
  "Thiếu bộ xử lý PDFium.": "The PDFium engine is missing.",
  "Không đủ bộ nhớ để xử lý PDF.": "Not enough memory to process the PDF.",
  "Không thể đổi vị trí đối tượng PDF.": "Could not reposition the PDF object.",
  "Không thể thay nội dung chữ gốc.": "Could not replace the original text.",
  "Bộ xử lý PDF đã đóng.": "The PDF engine has been closed.",
  "Dữ liệu PDF không hợp lệ.": "Invalid PDF data.",
  "PDF được bảo vệ bằng mật khẩu.": "This PDF is password-protected.",
  "Không đọc được file PDF này.": "Could not read this PDF file.",
  "Trang PDF không hợp lệ.": "Invalid PDF page.",
  "Không đọc được trang PDF.": "Could not read the PDF page.",
  "PDF có quá nhiều cấp nhóm lồng nhau.": "This PDF has too many levels of nested groups.",
  "Trang PDF có quá nhiều đối tượng để chỉnh sửa an toàn.": "This PDF page has too many objects to edit safely.",
  "Không thể tách đối tượng gốc khỏi PDF.": "Could not detach the original object from the PDF.",
  "Không tạo được bản PDF mới.": "Could not create a new PDF.",
  "Không lưu được PDF.": "Could not save the PDF.",
  "Bản PDF xuất chưa đầy đủ.": "The exported PDF is incomplete.",
  "Không đọc được font TTF/OTF này.": "Could not read this TTF/OTF font.",
  "Font này cần có file TTF/OTF để nhúng vào PDF.": "This font requires a TTF/OTF file to embed it in the PDF.",
  "Đoạn chữ quá dài để chỉnh sửa trong một lần.": "This text is too long to edit in one operation.",
  "Cỡ chữ hoặc giãn dòng không hợp lệ.": "Invalid font size or line spacing.",
  "Không đo được đoạn chữ này.": "Could not measure this text.",
  "Đoạn chữ có quá nhiều dòng.": "This text has too many lines.",
  "Không tạo được dòng chữ mới.": "Could not create a new line of text.",
  "Thao tác chỉnh sửa không hợp lệ.": "Invalid edit operation.",
  "Đối tượng đã thay đổi. Hãy chọn lại nội dung.": "The object has changed. Select the content again.",
  "Đối tượng đã bị xóa trong thao tác này.": "The object was already deleted in this operation.",
  "Không chèn được dòng chữ mới.": "Could not insert the new line of text.",
  "Đối tượng được chọn không phải chữ gốc.": "The selected object is not original text.",
  "Cỡ chữ không hợp lệ.": "Invalid font size.",
  "Nội dung nhiều dòng cần bố trí thành các dòng chữ riêng.": "Multiline content must be laid out as separate text lines.",
  "Không tạo được nội dung chữ mới.": "Could not create the new text content.",
  "Không chèn lại được nội dung chữ.": "Could not reinsert the text content.",
  "Không đổi được màu tô của đối tượng.": "Could not change the object’s fill color.",
  "Không đổi được màu viền của đối tượng.": "Could not change the object’s stroke color.",
  "Độ dày viền không hợp lệ.": "Invalid stroke width.",
  "Không đổi được trạng thái đối tượng.": "Could not change the object’s visibility.",
  "Phép biến đổi không hợp lệ.": "Invalid transform.",
  "Đối tượng được chọn không phải ảnh.": "The selected object is not an image.",
  "Ảnh thay thế không hợp lệ.": "Invalid replacement image.",
  "Không đủ bộ nhớ cho ảnh thay thế.": "Not enough memory for the replacement image.",
  "Không thay được ảnh gốc.": "Could not replace the original image.",
  "Thứ tự đối tượng không hợp lệ.": "Invalid object order.",
  "Không đổi được thứ tự đối tượng.": "Could not change the object order.",
  "Không dựng lại được nhóm nội dung PDF.": "Could not rebuild the PDF content group.",
  "Không tách được thành phần trong nhóm PDF.": "Could not detach an object from the PDF group.",
  "Không tạo được nội dung nhóm PDF.": "Could not generate the PDF group content.",
  "Không tạo được nội dung trang PDF.": "Could not generate the PDF page content.",
  "Font gốc thiếu ký tự mới. Hãy chọn font hỗ trợ tiếng Việt hoặc tải font TTF/OTF.": "The original font lacks the new characters. Choose a font that supports Vietnamese or load a TTF/OTF font.",
  "Bản xem trước quá lớn. Hãy giảm thu phóng.": "The preview is too large. Zoom out to continue.",
  "Không đủ bộ nhớ cho bản xem trước.": "Not enough memory for the preview.",
  "Không thể khởi động bộ chỉnh sửa PDF.": "Could not start the PDF editor.",
  "Phiên chỉnh sửa đã đóng.": "The editing session has been closed.",
  "Đã hủy thao tác.": "Operation canceled.",
  "Không tải được bộ chỉnh sửa PDF.": "Could not load the PDF editor.",
  "Không thể chỉnh nội dung PDF này.": "Could not edit this PDF content.",
  "Rã PDF": "Edit PDF",
  "Rã PDF · chỉnh nội dung gốc": "Edit PDF objects · edit original content",
  "Không thể vừa xóa nhóm vừa chỉnh thành phần trong nhóm.": "A group cannot be deleted while its contents are being edited in the same operation.",
  "Chữ này có đánh dấu cấu trúc, độ trong suốt hoặc clipping đặc biệt. Chỉ có thể sửa nội dung với font và bố cục gốc.": "This text has structural tags, transparency or special clipping. Only its content can be edited, using the original font and layout.",
  "Xong": "Done",
  "Xoay trang": "Rotate page",
  "Không thể giữ nội dung ẩn sau khi cắt trang.": "Could not preserve hidden content after cropping the page.",
  "Tô nền": "Fill",
  "Không đọc được chế độ tô vector.": "Could not read the vector fill mode.",
  "Không đổi được chế độ tô vector.": "Could not change the vector fill mode.",
  "Sửa chữ, ảnh và vector gốc; thêm nội dung và tinh chỉnh trang PDF.": "Edit original text, images and vectors; add content and fine-tune PDF pages.",
  "Có khả năng là người": "Likely human",
  "có khả năng là người": "likely human",
  "Phân loại là ước tính theo từng request, không phải số người duy nhất. Bot tốt như công cụ tìm kiếm cũng cần được nhận diện riêng; không tự động chặn tất cả crawler.": "Classification is an estimate per request, not a count of unique people. Good bots such as search engines should remain distinguishable; do not automatically block every crawler.",
  "Đã xác minh hoặc nghi là bot": "Verified or suspected bot",
  "Ghi nhận request tài liệu HTML tới máy chủ; điều hướng trong ứng dụng không tự tính thêm. Bot / crawler gồm tín hiệu đã xác minh và các request có dấu hiệu tự động; các nhãn còn lại chỉ là ước tính, không xác minh danh tính.": "HTML document requests reaching the server are counted; in-app navigation does not add another request. Bot / crawler includes verified signals and requests showing automation signs; the other labels are estimates, not identity verification."
}
